import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { BASE_URL, BASE_URL_PREBID } from "./axios";
import { ToastContainer, toast } from "react-toastify";
import { UpdatePencil, DropdownArrow, SearchBig, CrosswithGreyCircle, AddwithWhiteCircle, DocImg, UpdatePencilWhite, DeleteDustbin, CloudUpload, Eye } from "../../utils/ReusableSVGs";
import { CSSForSelect } from "../../utils/ReusableStylings";
import { Modal, ModalHeader, ModalBody } from 'react-bootstrap';

// import Createnewall from "../Modals/Createnewall";
import { handleErrorToast } from "../../utils/ReusableFunctions";
import Select from "react-select";

const AddActivity = ({ projectID, department_name, getDepartmentList, weightage }) => {
    const [fileNames, setFileNames] = useState([]);
    console.log(weightage, 'weightage')
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        activity_name: '',
        activity_type: 'internal',
        activity_description: '',
        project_detail: projectID ? projectID : "",
        department: department_name ? department_name : "",
        // activity_parent: '',
        assigned_by: '',
        assigned_to: [],
        weightage: '',
        assign_date: '',
        deadline_date: '',
        uploaded_file: "",
        vendor_name: '',
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            'activity_name',
            'activity_type',
            'weightage',
            // "assign_date",
            // "deadline_date",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)


    const [selectedFile, setSelectedFile] = useState(null);
    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        // const file = e.target.files[0];
        // setSelectedFile(file);
        const file = e?.target?.files;
        if (file && files.length > 0) {
            const file = files[0];
            setSelectedFile(file);
            // Clear any previous errors if needed
            setErrors({ length: 0 });
        } else {
            // Handle case where no file is selected (optional)
            setSelectedFile(null);
            setErrors({ length: 1 }); // or whatever logic you prefer
        }
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = allActivity.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > weightage) {
                console.log("100")
                newErrors.weightage = `Total weightage cannot be exceeds  ${weightage} (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };





    const handleShow = () => {
        setShow(true);


    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }


    const [allEmployeeData, setAllEmployeeData] = useState([]);


    const [allActivity, setAllActivity] = useState([]);

    const fetchActivity = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/detail-design/activityfilter-by-department/${department_name}/`);
            setAllActivity(res.data);
        } catch (err) {

        }
    };

    useEffect(() => {
        if (show) {
            getEmployeeDetails();
            fetchActivity()
        }

    }, [show]);



    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const assigned_to = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            assigned_to,
        }));
    };

    const handleFormSubmit = async (e) => {
        console.log("clicked")
        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formData).forEach((key) => {
                    if (formData[key] && key !== "uploaded_file") {
                        formDataToSend.append(key, formData[key]);
                    }
                });




                const symbols = "!@#$%^&*()_-+=";
                const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const now = new Date();
                const date = now
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .reverse()
                    .join("-");
                const time = now
                    .toLocaleTimeString("en-GB", { hour12: false })
                    .replace(/:/g, "-");
                const allChars =
                    symbols + lowercaseLetters + uppercaseLetters + numbers;
                let randomCode = "";
                for (let i = 0; i < 8; i++) {
                    const randomIndex = Math.floor(Math.random() * allChars.length);
                    randomCode += allChars[randomIndex];
                }

                const originalFile2 = formData.uploaded_file;
                const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2.name}`;
                const customFile2 = new File([originalFile2], customFileName2, {
                    type: originalFile2.type,
                });




                if (formData.uploaded_file) {
                    formDataToSend.append("uploaded_file", customFile2);
                }



                let res = await axios.post(
                    `${BASE_URL}/detail-design/activitytype/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };




    return (
        <>
            <button
                title="Add Detail Design"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Add Activity
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Activity</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_name"
                                    value={formData.activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Activity Discription <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_description"
                                    value={formData.activity_description}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.activity_description ? 'error' : inputState.activity_description ? 'success' : ''}`}
                                />
                                {errors.activity_description && <span className="error-message">{errors.activity_description}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Type <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Activity Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            {/* <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Parent <span className="required">*</span></label>



                                {allActivity.length === 0 ?
                                    (
                                        <div className="form-loader">
                                            <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="activity_parent"
                                                name="activity_parent"
                                                value={formData.activity_parent}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.activity_parent
                                                    ? "error"
                                                    : inputState.activity_parent
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Activity</option>
                                                {allActivity?.sort((a, b) => a?.activity_name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i?.activity_name}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                </svg>
                                            </div>
                                            <div>
                                                {errors.department && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.department}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}

                            </div> */}

                            {formData?.activity_type === "internal" ?
                                (
                                    <>
                                        <div title="assigned_by" className="flex-column form-group-selectt">
                                            <label htmlFor="assigned_by" className="form-labels font-weight500 font-size-subheading">
                                                Team Lead<span className="required">*</span>
                                            </label>

                                            {allEmployeeData.length === 0 ?
                                                <div className="form-loader">
                                                    <div className="bar-loader"></div>
                                                </div> :
                                                <>
                                                    <select
                                                        id="assigned_by"
                                                        name="assigned_by"
                                                        value={formData.assigned_by} // Changed from `project` to `team_lead`
                                                        onChange={handleInputChange}
                                                        className={`form-input form-group-selection ${errors.assigned_by ? "error" : inputState.assigned_by ? "success" : ""}`}

                                                    >
                                                        <option value="">Select Team Lead</option>
                                                        {allEmployeeData?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                            <option key={index} value={i.emp_code}>
                                                                {`${i.emp_code} - ${i.name}`} {/* Adjusted to show the structure name */}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        {errors.assigned_by && (
                                                            <span className="error-message font-size-text ">{errors.assigned_by}</span>
                                                        )}
                                                    </div>
                                                </>}
                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Assigned To:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectEmployee}
                                                value={formData.assigned_to?.map((code) => ({
                                                    value: code,
                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.employee && (
                                                <span className="error-message font-size-text ">{errors.employee}</span>
                                            )}
                                        </div>
                                    </>)
                                : (<>
                                    {/* <div title="Vendor Name" className="flex-column form-group-selectt">
                                        <label htmlFor="vendor_name" className="form-labels  font-weight500    font-size-subheading">
                                            Select Existing Vendor <span className="required">*</span>
                                        </label>

                                        <select
                                            id="vendor_name"
                                            name="vendor_name"
                                            value={formData?.vendor_name}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.vendor_name ? "error" : inputState.vendor_name ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select a Vendor</option>
                                            {vendorList?.sort((a, b) => a?.name?.localeCompare(b.company_name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                {console.log(i)}
                                                <option value={i?.id}>{i?.name}</option>
                                            </>))
                                            }
                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors.vendor_name && (
                                                <span className="error-message font-size-text ">{errors.vendor_name}</span>
                                            )}
                                        </div>
                                    </div> */}
                                </>)}

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>

                                    <input
                                        type="date"
                                        id="assign_date"
                                        name="assign_date"
                                        value={formData.assign_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                    />

                                    {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}

                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Deadline Date*</label>

                                    <input
                                        type="date"
                                        id="deadline_date"
                                        name="deadline_date"
                                        value={formData.deadline_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                    />

                                    {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}

                                </div>

                            </div>



                            <div
                                className={
                                    formData?.activity_type === "internal"
                                        ? "flex-column full-width-form"
                                        : "flex-column"
                                }
                            >
                                <label className="form-labels">
                                    Documentations : <span className="required">*</span>
                                </label>
                                <label
                                    className="form-input-doc full-width-form"
                                    htmlFor="uploaded_file"
                                >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">
                                        {selectedFile ? selectedFile.name : "Select File"}
                                    </span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    onChange={handleInputChange}
                                    style={{ display: "none" }}
                                />

                                {errors.length > 0 && (
                                    <span className="error-message">{errors.length}</span>
                                )}
                            </div>

                        </div>


                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Add</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

const EditActivity = ({ i, projectID, department_name, getDepartmentList, weightage }) => {
    const [fileNames, setFileNames] = useState([]);
    console.log(i, 'i')
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        activity_name: '',
        activity_type: '',
        activity_description: '',
        project_detail: projectID ? projectID : "",
        department_name: department_name ? department_name : "",
        activity_parent: '',
        assigned_by: '',
        assigned_to: '',
        weightage: '',
        assign_date: '',
        deadline_date: '',
        uploaded_file: "",
        vendor_name: '',
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            'activity_name',
            'activity_type',
            'weightage',
            // "assign_date",
            // "deadline_date",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)


    const [selectedFile, setSelectedFile] = useState(null);
    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        const file = e?.target?.files;
        if (file && files.length > 0) {
            const file = files[0];
            setSelectedFile(file);
            // Clear any previous errors if needed
            setErrors({ length: 0 });
        } else {
            // Handle case where no file is selected (optional)
            setSelectedFile(null);
            setErrors({ length: 1 }); // or whatever logic you prefer
        }
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = allActivity.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > weightage) {
                console.log("100")
                newErrors.weightage = `Total weightage cannot be exceeds  ${weightage} (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };





    const handleShow = () => {
        setShow(true);
        setFormData(i)

    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }


    const [allEmployeeData, setAllEmployeeData] = useState([]);


    const [allActivity, setAllActivity] = useState([]);

    const fetchActivity = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/detail-design/activitytype/`);
            setAllActivity(res.data);
        } catch (err) {

        }
    };

    useEffect(() => {

        getEmployeeDetails();
        fetchActivity()
    }, []);



    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const assigned_to = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            assigned_to,
        }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formData).forEach((key) => {
                    if (formData[key] && key !== "uploaded_file") {
                        formDataToSend.append(key, formData[key]);
                    }
                });




                const symbols = "!@#$%^&*()_-+=";
                const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const now = new Date();
                const date = now
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .reverse()
                    .join("-");
                const time = now
                    .toLocaleTimeString("en-GB", { hour12: false })
                    .replace(/:/g, "-");
                const allChars =
                    symbols + lowercaseLetters + uppercaseLetters + numbers;
                let randomCode = "";
                for (let i = 0; i < 8; i++) {
                    const randomIndex = Math.floor(Math.random() * allChars.length);
                    randomCode += allChars[randomIndex];
                }

                const originalFile2 = formData.uploaded_file;
                const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2.name}`;
                const customFile2 = new File([originalFile2], customFileName2, {
                    type: originalFile2.type,
                });





                formDataToSend.append("uploaded_file", customFile2);


                let res = await axios.put(
                    `${BASE_URL}/detail-design/activitytype/${i.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button
                title="Add Detail Design"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Edit Activity
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Edit Activity</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_name"
                                    value={formData?.activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.activity_name ? 'error' : inputState.activity_name ? 'success' : ''}`}
                                />
                                {errors.activity_name && <span className="error-message">{errors.activity_name}</span>}
                            </div>
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Type <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData?.activity_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors?.activity_type
                                        ? "error"
                                        : inputState?.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Activity Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors?.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors?.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>


                            <div className="flex-column">
                                <label className="form-labels">Activity Discription <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_description"
                                    value={formData?.activity_description}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.activity_description ? 'error' : inputState.activity_description ? 'success' : ''}`}
                                />
                                {errors.activity_description && <span className="error-message">{errors.activity_description}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Parent <span className="required">*</span></label>



                                {allActivity.length === 0 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                    </div>
                                ) : (
                                    <>
                                        <select
                                            id="activity_parent"
                                            name="activity_parent"
                                            value={formData?.activity_parent}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.activity_parent
                                                ? "error"
                                                : inputState.activity_parent
                                                    ? "success"
                                                    : ""
                                                }`}
                                        >
                                            <option value="">Select a Activity</option>

                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors.department && (
                                                <span className="error-message font-size-text ">
                                                    {errors.department}
                                                </span>
                                            )}
                                        </div>
                                    </>
                                )}

                            </div>

                            {formData?.activity_type === "internal" ?
                                (
                                    <>
                                        <div title="assigned_by" className="flex-column form-group-selectt">
                                            <label htmlFor="assigned_by" className="form-labels font-weight500 font-size-subheading">
                                                Team Lead<span className="required">*</span>
                                            </label>

                                            {allEmployeeData.length === 0 ?
                                                <div className="form-loader">
                                                    <div className="bar-loader"></div>
                                                </div> :
                                                <>
                                                    <select
                                                        id="assigned_by"
                                                        name="assigned_by"
                                                        value={formData.assigned_by} // Changed from `project` to `team_lead`
                                                        onChange={handleInputChange}
                                                        className={`form-input form-group-selection ${errors.assigned_by ? "error" : inputState.assigned_by ? "success" : ""}`}

                                                    >
                                                        <option value="">Select Team Lead</option>
                                                        {allEmployeeData?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                            <option key={index} value={i.emp_code}>
                                                                {`${i.emp_code} - ${i.name}`} {/* Adjusted to show the structure name */}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        {errors.assigned_by && (
                                                            <span className="error-message font-size-text ">{errors.assigned_by}</span>
                                                        )}
                                                    </div>
                                                </>}
                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Assigned To:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectEmployee}
                                                value={formData.assigned_to?.map((code) => ({
                                                    value: code,
                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.employee && (
                                                <span className="error-message font-size-text ">{errors.employee}</span>
                                            )}
                                        </div>
                                    </>)
                                : (<>
                                    <div className="flex-column">
                                        <label className="form-labels">Vendor Name<span className="required">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter the Vendor Name"
                                            name="vendor_name"
                                            value={formData?.vendor_name}
                                            onChange={handleInputChange}
                                            className={`activity-form form-input  ${errors.vendor_name ? 'error' : inputState.vendor_name ? 'success' : ''}`}
                                        />
                                        {errors.vendor_name && <span className="error-message">{errors.vendor_name}</span>}
                                    </div>
                                </>)}
                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData?.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>

                                    <input
                                        type="date"
                                        id="assign_date"
                                        name="assign_date"
                                        value={formData?.assign_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                    />

                                    {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}

                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Deadline Date*</label>

                                    <input
                                        type="date"
                                        id="deadline_date"
                                        name="deadline_date"
                                        value={formData?.deadline_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                    />

                                    {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}

                                </div>

                            </div>

                            {/* <div
                                // className="flex-column full-width-form"
                                className={formData?.activity_type === "internal" ? "flex-column full-width-form" : "flex-column"}
                            >
                                <label className="form-labels"> Documentations : <span className="required">*</span></label>
                                <label className="form-input-doc full-width-form" htmlFor="uploaded_file" >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">Select File</span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    onChange={handleInputChange}
                                    // className={`form-input  ${errors.length ? 'error' : inputState.length ? 'success' : ''}`}
                                    style={{ display: "none" }}
                                />
                                {errors.length && <span className="error-message">{errors.length}</span>}
                            </div> */}

                            <div
                                className={
                                    formData?.activity_type === "internal"
                                        ? "flex-column full-width-form"
                                        : "flex-column"
                                }
                            >
                                <label className="form-labels">
                                    Documentations : <span className="required">*</span>
                                </label>
                                <label
                                    className="form-input-doc full-width-form"
                                    htmlFor="uploaded_file"
                                >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">
                                        {selectedFile ? selectedFile.name : "Select File"}
                                    </span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    onChange={handleInputChange}
                                    style={{ display: "none" }}
                                />

                                {errors.length > 0 && (
                                    <span className="error-message">{errors.length}</span>
                                )}
                            </div>

                        </div>


                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Add</button>
                            <button
                                // onclick={handleClose} 
                                className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

const AddDepartment = ({ projectID, getDepartmentList, departmentlist }) => {
    const [fileNames, setFileNames] = useState([]);

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        department: '',
        team_lead: [],
        employee: [],
        project: projectID ? projectID : "",
        department_type: '',
        division_name: '',
        weightage: "",
        division_head_name: [],

        // name: "",
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [

            'department_type',
            // 'client',
            // "sub_Company",
            // "concern_person",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {



                let res = await axios.post(
                    `${BASE_URL}/detail-design/highwaydepartment/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "Application/json",
                        },
                    }
                );

                if (res.status === 200 || res.status === 201) {
                    setShow(false);
                    handleClose();
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };



    console.log("projectID")
    console.log(projectID)

    console.log("formData")
    console.log(formData)



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = departmentlist.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > 100) {
                console.log("100")
                newErrors.weightage = `Total weightage exceeds 100% (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));





        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        setFormData2((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };





    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData({
            department: '',
            team_lead: [],
            employee: [],
            project: projectID ? projectID : "",
            department_type: '',
            division_name: '',
            weightage: "",
            division_head_name: [],
        })

    }

    const [project, setProject] = useState([]);
    const [allEmployeeData, setAllEmployeeData] = useState([]);
    const getAllproject = async () => {
        try {
            const sub = await axios.get(
                `${BASE_URL}/project_details/project-filter/null/null/`
            );
            setProject(sub.data);
        } catch (err) {
        } finally {
        }
    };

    const [allDepartments, setAllDepartments] = useState([]);

    const fetchDepartments = async () => {
        const id = '025d0b52-e892-4868-a3bb-6b70dcdffb4d';
        try {
            const res = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${id}/active/`);
            setAllDepartments(res.data);
        } catch (err) {
            toast.error("Failed to fetch departments.");
        }
    };

    useEffect(() => {
        if (show) {
            setFormData((prevState) => ({
                ...prevState,
                department_type: 'internal',
            }));
            getAllproject();
            getEmployeeDetails();
            fetchDepartments()
        }

    }, [show]);

    const selectTeamlead = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const team_lead = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            team_lead,
        }));
    };

    const selectheadDivision = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const division_head_name = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            division_head_name,
        }));
    };

    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const employee = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            employee,
        }));
    };

    // add Vender??/////////////////////////////////////////////////////////////

    const [formdata2, setFormData2] = useState({
        name: "",
        contact_person: "",
        // sub_Company: "",
        address: "",
        email: "",
        contact_number: "",
        alt_contact_number: "",
        gstin_number: "",
        pos: ""
    })

    const validateform2 = () => {
        const newErrors = {};
        const requiredFields = [
            // "sub_Company",
            "pos",
            "name",
            "gstin_number",

        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });





        setErrors(newErrors);
        // setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };
    const [sub_CompanyList, setsub_CompanyList] = useState([]);
    const [showForm, setShowForm] = useState(false);

    const handleAddVendor = () => {
        setShowForm(!showForm);
    };




    // console.log(formData, "formData");




    return (
        <>
            <button
                title="Add Division"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle />  Department
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Department</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Division Type <span className="required">*</span></label>
                                <select
                                    id="department_type"
                                    name="department_type"
                                    value={formData.department_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.department_type
                                        ? "error"
                                        : inputState.department_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Department Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.department_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.department_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.location ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>
                            {formData?.department_type === "internal" ?
                                (
                                    <>
                                        <div Title='Name of Division' className="flex-column">
                                            <label className="form-labels">Name Of Division<span className="required">*</span></label>
                                            <input
                                                type="text"
                                                placeholder="Name of Division"
                                                name="division_name"
                                                value={formData.division_name}
                                                onChange={handleInputChange}
                                                className={`activity-form form-input  ${errors.division_name ? 'error' : inputState.division_name ? 'success' : ''}`}
                                            />
                                            {errors.division_name && <span className="error-message">{errors.division_name}</span>}
                                        </div>


                                        <div className="flex-column form-group-selectt">
                                            <label className="form-labels">Department <span className="required">*</span></label>



                                            {allDepartments.length === 0 ? (
                                                <div className="form-loader">
                                                    <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                                </div>
                                            ) : (
                                                <>
                                                    <select
                                                        id="department"
                                                        name="department"
                                                        value={formData.department}
                                                        onChange={handleInputChange}
                                                        className={`form-input form-group-selection ${errors.department
                                                            ? "error"
                                                            : inputState.department
                                                                ? "success"
                                                                : ""
                                                            }`}
                                                    >
                                                        <option value="">Select a Department</option>
                                                        {allDepartments
                                                            ?.sort((a, b) =>
                                                                a?.name?.localeCompare(b.project_name, "en", {
                                                                    ignorePunctuation: true,
                                                                })
                                                            )
                                                            .map((i, index) => (
                                                                <>

                                                                    <option value={i.id}>{`${i?.department ? `${i.id}-` : ""}${i.title}`}</option>
                                                                </>
                                                            ))}
                                                    </select>
                                                    <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        {errors.department && (
                                                            <span className="error-message font-size-text ">
                                                                {errors.department}
                                                            </span>
                                                        )}
                                                    </div>
                                                </>
                                            )}

                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Head Of Division:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectheadDivision}
                                                value={formData.assignedto?.map((code) => ({
                                                    value: code,
                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.division_head_name && (
                                                <span className="error-message font-size-text ">{errors.division_head_name}</span>
                                            )}
                                        </div>

                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Team Lead:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectTeamlead}
                                                value={formData.assignedto?.map((code) => ({
                                                    value: code,
                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.team_lead && (
                                                <span className="error-message font-size-text ">{errors.team_lead}</span>
                                            )}
                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Employee:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectEmployee}
                                                value={formData.assignedto?.map((code) => ({
                                                    value: code,
                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.employee && (
                                                <span className="error-message font-size-text ">{errors.employee}</span>
                                            )}
                                        </div>
                                    </>
                                ) :
                                (<>

                                </>)}









                        </div>


                        <div className="button-models-add">
                            <button onClick={handleSubmit} className="model-button-add">Add</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}
const EditDepartment = ({ i, projectID, getDepartmentList, departmentlist, getProjectDetails }) => {
    const [fileNames, setFileNames] = useState([]);

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        department: '',
        team_lead: '',
        employee: '',
        project: projectID ? projectID : "",
        department_type: 'internal',
        division_name: '',
        weightage: "",
        division_head_name: "",

        // name: "",
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [

            'department_type',

        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {



                let res = await axios.put(
                    `${BASE_URL}/detail-design/highwaydepartment/${i.id}/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "Application/json",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = departmentlist.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > 100) {
                console.log("100")
                newErrors.weightage = `Total weightage exceeds 100% (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));



        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };






    const handleShow = () => {
        console.log(i, "i")
        setFormData(i)
        setShow(true);

    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }

    const [project, setProject] = useState([]);
    const [allEmployeeData, setAllEmployeeData] = useState([]);
    const getAllproject = async () => {
        try {
            const sub = await axios.get(
                `${BASE_URL}/project_details/project-filter/null/null/`
            );
            setProject(sub.data);
        } catch (err) {
        } finally {
        }
    };

    const [allDepartments, setAllDepartments] = useState([]);

    const fetchDepartments = async () => {
        const id = '025d0b52-e892-4868-a3bb-6b70dcdffb4d';
        try {
            const res = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${id}/active/`);
            setAllDepartments(res.data);
        } catch (err) {
            toast.error("Failed to fetch departments.");
        }
    };

    useEffect(() => {
        if (show) {
            setFormData((prevState) => ({
                ...prevState,
                department_type: 'internal',
            }));
            getAllproject();
            getEmployeeDetails();
            fetchDepartments()
        }

    }, [show]);

    const selectTeamlead = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const team_lead = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            team_lead,
        }));
    };

    const selectheadDivision = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const division_head_name = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            division_head_name,
        }));
    };

    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const employee = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            employee,
        }));
    };

    // add Vender??/////////////////////////////////////////////////////////////








    return (
        <>
            <button
                title="Edit Division"
                className="common-button"
                onClick={handleShow}
            >
                <svg xmlns="http://www.w3.org/2000/svg"
                    width="20" height="20" enable-background="new 0 0 32 32" viewBox="0 0 32 32" fill='white'
                    id="edit">
                    <path d="M3.5,24h15A3.51,3.51,0,0,0,22,20.487V12.95a1,1,0,0,0-2,0v7.537A1.508,1.508,0,0,1,18.5,22H3.5A1.508,1.508,0,0,1,2,20.487V5.513A1.508,1.508,0,0,1,3.5,4H11a1,1,0,0,0,0-2H3.5A3.51,3.51,0,0,0,0,5.513V20.487A3.51,3.51,0,0,0,3.5,24Z"></path><path d="M9.455,10.544l-.789,3.614a1,1,0,0,0,.271.921,1.038,1.038,0,0,0,.92.269l3.606-.791a1,1,0,0,0,.494-.271l9.114-9.114a3,3,0,0,0,0-4.243,3.07,3.07,0,0,0-4.242,0l-9.1,9.123A1,1,0,0,0,9.455,10.544Zm10.788-8.2a1.022,1.022,0,0,1,1.414,0,1.009,1.009,0,0,1,0,1.413l-.707.707L19.536,3.05Zm-8.9,8.914,6.774-6.791,1.4,1.407-6.777,6.793-1.795.394Z"></path></svg>
                Edit Department
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Edit Department</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Division Type <span className="required">*</span></label>
                                <select
                                    id="department_type"
                                    name="department_type"
                                    value={formData?.department_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.department_type
                                        ? "error"
                                        : inputState.department_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Department Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.department_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.department_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData?.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.location ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>
                            {formData?.department_type === "internal" ? (
                                <>
                                    <div className="flex-column">
                                        <label className="form-labels">Name Of Division<span className="required">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Name of Division"
                                            name="division_name"
                                            value={formData?.division_name}
                                            onChange={handleInputChange}
                                            className={`activity-form form-input  ${errors.division_name ? 'error' : inputState.division_name ? 'success' : ''}`}
                                        />
                                        {errors.division_name && <span className="error-message">{errors.division_name}</span>}
                                    </div>


                                    <div className="flex-column form-group-selectt">
                                        <label className="form-labels">Department <span className="required">*</span></label>



                                        {allDepartments.length === 0 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                            </div>
                                        ) : (
                                            <>
                                                <select
                                                    id="department"
                                                    name="department"
                                                    value={formData?.department}
                                                    onChange={handleInputChange}
                                                    className={`form-input form-group-selection ${errors.department
                                                        ? "error"
                                                        : inputState.department
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                >
                                                    <option value="">Select a Department</option>
                                                    {allDepartments
                                                        ?.sort((a, b) =>
                                                            a?.name?.localeCompare(b.project_name, "en", {
                                                                ignorePunctuation: true,
                                                            })
                                                        )
                                                        .map((i, index) => (
                                                            <>

                                                                <option value={i.id}>{`${i?.department ? `${i.id}-` : ""}${i.title}`}</option>
                                                            </>
                                                        ))}
                                                </select>
                                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    {errors.department && (
                                                        <span className="error-message font-size-text ">
                                                            {errors.department}
                                                        </span>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                    </div>
                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Head Of Division:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectheadDivision}
                                            value={formData?.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.division_head_name && (
                                            <span className="error-message font-size-text ">{errors?.division_head_name}</span>
                                        )}
                                    </div>

                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Team Lead:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectTeamlead}
                                            value={formData?.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.team_lead && (
                                            <span className="error-message font-size-text ">{errors.team_lead}</span>
                                        )}
                                    </div>
                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Employee:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectEmployee}
                                            value={formData.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.employee && (
                                            <span className="error-message font-size-text ">{errors.employee}</span>
                                        )}
                                    </div>
                                </>
                            ) : (<>

                                {/* *********************************************** External vender *********************************** */}




                            </>)}









                        </div>


                        <div className="button-models-add">
                            <button onClick={handleSubmit} className="model-button-add">Edit</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

const DepartmentDelete = ({ i, projectID, getDepartmentList }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/detail-design/highwaydepartment/${i.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getDepartmentList();
                setShow(false);
            } else {
                // ;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Insurance"
                className="common-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#FFF"
                    />
                </svg>

            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Departrtment {i.division_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Departrtment  {i.division_name}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

const ActivityDelete = ({ i, projectID, getDepartmentList, intable }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false)
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/detail-design/activitytype/${i.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getDepartmentList();
                setShow(false);
            } else {
                // ;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    console.log(intable)
    return (
        <>
            {intable ?
                <button>
                    <span className="action-menu-dropdown-button delete-button" onClick={handleShow}>

                        Remove

                    </span>
                </button>
                :
                <button
                    title="Delete Insurance"
                    className="model-delete-button"
                    onClick={handleShow}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                    >
                        <path
                            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                            fill="#F72B50"
                        />
                    </svg>
                </button>}



            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Active {i.activity_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Activity {i.activity_name}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};





const AddTask = ({ projectID, getTaskList, tasklist, department_name }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);


    const handleShow = () => {
        setShow(true)
    };

    const handleClose = () => {
        setShow(false);
        setFormData({
            task_name: '',
            project: projectID ? projectID : '',
            assign_by: '',
            assigned_to: [],
            priority: 'low',
            task_parent: '',
            department: department_name ? department_name : "",
            remarks: '',
            uploaded_file: null,
            status: 'pending',
            assigned_date: '',
            deadline_date: ''
        });
        setErrors({});
    };

    const [formData, setFormData] = useState({
        task_name: '',
        project: projectID ? projectID : '',
        assign_by: '',
        assigned_to: [],
        priority: 'low',
        task_parent: '',
        department: department_name ? department_name : "",
        remarks: '',
        uploaded_file: null,
        status: 'pending',
        assigned_date: '',
        deadline_date: ''
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [projects, setProjects] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [departments, setDepartments] = useState([]);


    const priorityOptions = [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' }
    ];

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'inprogress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' }
    ];

    const validateForm = () => {
        const newErrors = {};

        if (!formData.task_name) newErrors.task_name = 'Task name is required';
        // if (!formData.project) newErrors.project = 'Project is required';
        if (!formData.assigned_date) newErrors.assigned_date = 'Start date is required';
        if (!formData.deadline_date) newErrors.deadline_date = 'Deadline is required';
        if (formData.assigned_to.length === 0) newErrors.assigned_to = 'At least one assignee is required';
        console.log(newErrors, 'neweeors')
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("clicked", formData)
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);
        try {
            const formPayload = new FormData();

            Object.keys(formData).forEach(key => {
                if (key === 'assigned_to') {
                    formData[key].forEach(value => formPayload.append(key, value));
                } else if (key === 'uploaded_file' && formData[key]) {
                    formPayload.append(key, formData[key]);
                } else if (formData[key] !== null && formData[key] !== '') {
                    formPayload.append(key, formData[key]);
                }
            });

            const res = await axios.post(
                `${BASE_URL}/project_details/task/`,
                formPayload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (res.status === 200 || res.status === 201) {
                setShow(false);
                handleClose();
                setErrors({});
                await getTaskList(department_name);
                toast.success("Task added successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        let newValue = type === 'file' ? files[0] : value;

        setInputState(prev => ({
            ...prev,
            [name]: newValue ? "green" : ""
        }));

        setFormData(prev => ({
            ...prev,
            [name]: newValue
        }));

        if (value.trim()) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const selectAssignBy = (selected) => {
        const assign_by = selected?.value || '';
        setFormData(prev => ({
            ...prev,
            assign_by
        }));
    };

    const selectAssignedTo = (selected) => {
        const assigned_to = selected?.map(item => item.value) || [];
        setFormData(prev => ({
            ...prev,
            assigned_to
        }));
    };


    const fetchDropdownData = async () => {
        try {

            const employeesRes = await axios.get(`${BASE_URL}/manpower/employee/`);

            console.log(employeesRes)


            setEmployees(employeesRes.data);


        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        if (show) {
            fetchDropdownData()
        }
    }, [show]);

    useEffect(() => {
        if (department_name) {
            setFormData(prev => ({
                ...prev,
                department: department_name
            }));
            // console.log(department_name, 'department name')
        }
    }, [department_name]);


    const employeeOptions = employees
        .sort((a, b) => {
            // Sort by name alphabetically
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        })
        .map(e => ({
            value: e.id,
            label: `${e.emp_code ? e.emp_code + ' - ' : ''}${e.name}`
        }));
    console.log(employeeOptions, employees, department_name, 'employeeoptions')


    return (
        <>
            <button
                title="Add Task"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Task
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="half-modal-new"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Task</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity" >
                        <div className='form-flex-wrap'>
                            {/* Task Name */}
                            <div className="flex-column">
                                <label className="form-labels">Task Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter task name"
                                    name="task_name"
                                    value={formData.task_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.task_name ? 'error' : inputState.task_name ? 'success' : ''}`}
                                />
                                {errors.task_name && <span className="error-message">{errors.task_name}</span>}
                            </div>

                            {/* Project */}


                            {/* Priority */}
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Priority</label>
                                <select
                                    id="priority"
                                    name="priority"
                                    value={formData.priority}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${inputState.priority ? "success" : ""}`}
                                >
                                    {priorityOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                            </div>

                            {/* Parent Task */}
                            <div className="flex-column">
                                <label className="form-labels">Parent Task</label>
                                <select
                                    id="task_parent"
                                    name="task_parent"
                                    value={formData.task_parent}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select Parent Task</option>
                                    {tasklist?.map(task => (
                                        <option key={task.id} value={task.id}>
                                            {task.task_name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="flex-column">
                                <label className="form-labels">Assigned By</label>
                                <Select
                                    options={employeeOptions}
                                    onChange={selectAssignBy}
                                    value={employeeOptions.find(opt => opt.id === formData.assign_by)}
                                    styles={CSSForSelect}
                                    placeholder="Select Assigner"
                                />
                            </div>

                            {/* Assigned To */}
                            <div className="flex-column form-group-select">
                                <label className="form-labels">Assigned To <span className="required">*</span></label>
                                <Select
                                    options={employeeOptions}
                                    isMulti
                                    onChange={selectAssignedTo}
                                    value={employeeOptions.find(opt => opt.id === formData.assigned_to)}
                                    styles={CSSForSelect}

                                    className={`${errors.assigned_to ? 'error-select' : ''}`}
                                    placeholder="Select Assignees"
                                />
                                {errors.assigned_to && (
                                    <span className="error-message font-size-text">{errors.assigned_to}</span>
                                )}
                            </div>

                            {/* Status */}
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status</label>
                                <select
                                    id="status"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${inputState.status ? "success" : ""}`}
                                >
                                    {statusOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                            </div>

                            {/* Date Fields */}
                            {/* <div className="date-box justify-between"> */}
                            <div className="flex-column">
                                <label htmlFor="assigned_date" className="form-labels">Start Date <span className="required">*</span></label>
                                <input
                                    type="date"
                                    id="assigned_date"
                                    name="assigned_date"
                                    value={formData.assigned_date}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.assigned_date ? 'error' : inputState.assigned_date ? 'success' : ''}`}
                                />
                                {errors.assigned_date && <span className="error-message">{errors.assigned_date}</span>}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="deadline_date" className="form-labels">Deadline <span className="required">*</span></label>
                                <input
                                    type="date"
                                    id="deadline_date"
                                    name="deadline_date"
                                    value={formData.deadline_date}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                />
                                {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}
                            </div>
                            {/* </div> */}

                            {/* File Upload */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Documentation</label>
                                <label className="form-input-doc full-width-form" htmlFor="uploaded_file">
                                    <CloudUpload />
                                    <span className="file-label-selectFile">
                                        {formData.uploaded_file ? formData.uploaded_file.name : "Select File"}
                                    </span>
                                </label>
                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    onChange={handleInputChange}
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    style={{ display: "none" }}
                                />
                            </div>

                            {/* Remarks */}
                            <div className="flex-column">
                                <label className="form-labels">Remarks</label>
                                <input
                                    type="text"
                                    placeholder="Add remarks"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                    className="form-input"
                                // style={{ width: "100%" }}
                                />
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? 'Adding...' : 'Add'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};




const UpdateTask = ({ i, projectID, getTaskList, tasklist, department_name }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);


    const handleShow = () => {
        setShow(true)
        setFormData(i)
    };

    const handleClose = () => {
        setShow(false);
        setFormData({
            task_name: '',
            project: projectID ? projectID : '',
            assign_by: '',
            assigned_to: [],
            priority: 'low',
            task_parent: '',
            department: department_name ? department_name : "",
            remarks: '',
            uploaded_file: null,
            status: 'pending',
            assigned_date: '',
            deadline_date: ''
        });
        setErrors({});
    };

    const [formData, setFormData] = useState({
        task_name: '',
        project: projectID ? projectID : '',
        assign_by: '',
        assigned_to: [],
        priority: 'low',
        task_parent: '',
        department: department_name ? department_name : "",
        remarks: '',
        uploaded_file: null,
        status: 'pending',
        assigned_date: '',
        deadline_date: ''
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [projects, setProjects] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [departments, setDepartments] = useState([]);


    const priorityOptions = [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' }
    ];

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'inprogress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' }
    ];

    const validateForm = () => {
        const newErrors = {};

        if (!formData.task_name) newErrors.task_name = 'Task name is required';
        // if (!formData.project) newErrors.project = 'Project is required';
        if (!formData.assigned_date) newErrors.assigned_date = 'Start date is required';
        if (!formData.deadline_date) newErrors.deadline_date = 'Deadline is required';
        if (formData.assigned_to.length === 0) newErrors.assigned_to = 'At least one assignee is required';
        console.log(newErrors, 'neweeors')
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("clicked", formData)
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);
        try {
            const formPayload = new FormData();

            Object.keys(formData).forEach(key => {
                if (key === 'assigned_to') {
                    formData[key].forEach(value => formPayload.append(key, value));
                } else if (key === 'uploaded_file' && formData[key]) {
                    formPayload.append(key, formData[key]);
                } else if (formData[key] !== null && formData[key] !== '') {
                    formPayload.append(key, formData[key]);
                }
            });

            const res = await axios.put(
                `${BASE_URL}/project_details/taskupdate/${i?.id}/`,
                formPayload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (res.status === 200 || res.status === 201) {
                setShow(false);
                handleClose();
                setErrors({});
                await getTaskList(department_name);
                toast.success("Task Updated successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        let newValue = type === 'file' ? files[0] : value;

        setInputState(prev => ({
            ...prev,
            [name]: newValue ? "green" : ""
        }));

        setFormData(prev => ({
            ...prev,
            [name]: newValue
        }));

        if (value.trim()) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const selectAssignBy = (selected) => {
        const assign_by = selected?.value || '';
        setFormData(prev => ({
            ...prev,
            assign_by
        }));
    };

    const selectAssignedTo = (selected) => {
        const assigned_to = selected?.map(item => item.value) || [];
        setFormData(prev => ({
            ...prev,
            assigned_to
        }));
    };


    const fetchDropdownData = async () => {
        try {

            const employeesRes = await axios.get(`${BASE_URL}/manpower/employee/`);

            console.log(employeesRes)


            setEmployees(employeesRes.data);


        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        if (show) {
            fetchDropdownData()
        }
    }, [show]);

    useEffect(() => {
        if (department_name) {
            setFormData(prev => ({
                ...prev,
                department: department_name
            }));
            // console.log(department_name, 'department name')
        }
    }, [department_name]);


    const employeeOptions = employees
        .sort((a, b) => {
            // Sort by name alphabetically
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        })
        .map(e => ({
            value: e.id,
            label: `${e.emp_code ? e.emp_code + ' - ' : ''}${e.name}`
        }));
    console.log(employeeOptions, employees, department_name, 'employeeoptions')


    return (
        <>
            <button title="Edit Task" onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="half-modal-new"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Update Task "{i.task_name}"</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity" >
                        <div className='form-flex-wrap'>
                            {/* Task Name */}
                            <div className="flex-column">
                                <label className="form-labels">Task Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter task name"
                                    name="task_name"
                                    value={formData.task_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.task_name ? 'error' : inputState.task_name ? 'success' : ''}`}
                                />
                                {errors.task_name && <span className="error-message">{errors.task_name}</span>}
                            </div>

                            {/* Project */}


                            {/* Priority */}
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Priority</label>
                                <select
                                    id="priority"
                                    name="priority"
                                    value={formData.priority}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${inputState.priority ? "success" : ""}`}
                                >
                                    {priorityOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                            </div>

                            {/* Parent Task */}
                            <div className="flex-column">
                                <label className="form-labels">Parent Task</label>
                                <select
                                    id="task_parent"
                                    name="task_parent"
                                    value={formData.task_parent}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select Parent Task</option>
                                    {tasklist?.map(task => (
                                        <option key={task.id} value={task.id}>
                                            {task.task_name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="flex-column">
                                <label className="form-labels">Assigned By</label>
                                <Select
                                    options={employeeOptions}
                                    onChange={selectAssignBy}
                                    value={employeeOptions.find(opt => opt.id === formData.assign_by)}
                                    styles={CSSForSelect}
                                    placeholder="Select Assigner"
                                />
                            </div>

                            {/* Assigned To */}
                            <div className="flex-column form-group-select">
                                <label className="form-labels">Assigned To <span className="required">*</span></label>
                                <Select
                                    options={employeeOptions}
                                    isMulti
                                    onChange={selectAssignedTo}
                                    value={employeeOptions.find(opt => opt.id === formData.assigned_to)}
                                    styles={CSSForSelect}

                                    className={`${errors.assigned_to ? 'error-select' : ''}`}
                                    placeholder="Select Assignees"
                                />
                                {errors.assigned_to && (
                                    <span className="error-message font-size-text">{errors.assigned_to}</span>
                                )}
                            </div>

                            {/* Status */}
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status</label>
                                <select
                                    id="status"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${inputState.status ? "success" : ""}`}
                                >
                                    {statusOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                            </div>

                            {/* Date Fields */}
                            {/* <div className="date-box justify-between"> */}
                            <div className="flex-column">
                                <label htmlFor="assigned_date" className="form-labels">Start Date <span className="required">*</span></label>
                                <input
                                    type="date"
                                    id="assigned_date"
                                    name="assigned_date"
                                    value={formData.assigned_date}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.assigned_date ? 'error' : inputState.assigned_date ? 'success' : ''}`}
                                />
                                {errors.assigned_date && <span className="error-message">{errors.assigned_date}</span>}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="deadline_date" className="form-labels">Deadline <span className="required">*</span></label>
                                <input
                                    type="date"
                                    id="deadline_date"
                                    name="deadline_date"
                                    value={formData.deadline_date}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                />
                                {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}
                            </div>
                            {/* </div> */}

                            {/* File Upload */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Documentation</label>
                                <label className="form-input-doc full-width-form" htmlFor="uploaded_file">
                                    <CloudUpload />
                                    <span className="file-label-selectFile">
                                        {formData.uploaded_file ? formData.uploaded_file.name : "Select File"}
                                    </span>
                                </label>
                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    onChange={handleInputChange}
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    style={{ display: "none" }}
                                />
                            </div>

                            {/* Remarks */}
                            <div className="flex-column">
                                <label className="form-labels">Remarks</label>
                                <input
                                    type="text"
                                    placeholder="Add remarks"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                    className="form-input"
                                // style={{ width: "100%" }}
                                />
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? 'Updating...' : 'Update'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};
const DeleteTask = ({ i, projectID, getTaskList, tasklist, department_name }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/project_details/taskupdate/${i?.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getTaskList(department_name);
                setShow(false);
            } else {
                // ;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Task" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Task {i.
                        task_name
                    }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Task  {i.
                            task_name
                        }
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};
const AddSubActivity = () => {

    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [formData, setFormData] = useState({

    })

    const handleShow = () => {
        setShow(true);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }

    const handleTaskSubmit = async (e) => {

    }



    return (
        <>
            <button
                title="Add Sub-Activity"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <ModalHeader
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Sub-Activity</h4></Modal.Title>
                </ModalHeader>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Sub-Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Sub-Activity Name"
                                    name="activity_name"
                                    value={formData.activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Description<span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Description"
                                    name="description"
                                    value={formData.descriptiom}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status<span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Status</option>
                                    <option value="internal">Pending</option>
                                    <option value="external">Completed</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>


                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign To:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            {/* <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Draftman:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div> */}

                            {/* <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Authority:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div> */}

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>

                                    <input
                                        type="date"
                                        id="assign_date"
                                        name="assign_date"
                                        value={formData.assign_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                    />

                                    {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}

                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Submission Date*</label>

                                    <input
                                        type="date"
                                        id="deadline_date"
                                        name="deadline_date"
                                        value={formData.deadline_date}
                                        // onChange={handleInputChange}
                                        className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                    />

                                    {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}

                                </div>

                            </div>

                            {/* <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Ststus Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div> */}

                            <div
                                className={
                                    formData?.activity_type === "internal"
                                        ? "flex-column full-width-form"
                                        : "flex-column"
                                }
                            >
                                <label className="form-labels">
                                    Documentations : <span className="required">*</span>
                                </label>
                                <label
                                    className="form-input-doc full-width-form"
                                    htmlFor="uploaded_file"
                                >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">
                                        {/* {selectedFile ? selectedFile.name : "Select File"} */}
                                    </span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    // onChange={handleInputChange}
                                    style={{ display: "none" }}
                                />

                                {errors.length > 0 && (
                                    <span className="error-message">{errors.length}</span>
                                )}
                            </div>

                        </div>



                        <div className="button-models-add">
                            <button onClick={handleTaskSubmit} className="model-button-add">Add</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>

                    </form>

                </Modal.Body>
            </Modal>

        </>
    )
};

const AddSubtask = () => {

    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [formData, setFormData] = useState({

    })

    const handleShow = () => {
        setShow(true);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }

    const handleTaskSubmit = async (e) => {

    }



    return (
        <>
            <button
                title="Add Sub-Activity"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <ModalHeader
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Sub-Activity</h4></Modal.Title>
                </ModalHeader>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Sub-Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Sub-Activity Name"
                                    name="activity_name"
                                    value={formData.activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Description<span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Description"
                                    name="description"
                                    value={formData.descriptiom}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status<span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Status</option>
                                    <option value="internal">Pending</option>
                                    <option value="external">Completed</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>


                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign To:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            {/* <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Draftman:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div> */}

                            {/* <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Authority:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div> */}

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>

                                    <input
                                        type="date"
                                        id="assign_date"
                                        name="assign_date"
                                        value={formData.assign_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                    />

                                    {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}

                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Submission Date*</label>

                                    <input
                                        type="date"
                                        id="deadline_date"
                                        name="deadline_date"
                                        value={formData.deadline_date}
                                        // onChange={handleInputChange}
                                        className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                    />

                                    {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}

                                </div>

                            </div>

                            {/* <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Ststus Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div> */}

                            <div
                                className={
                                    formData?.activity_type === "internal"
                                        ? "flex-column full-width-form"
                                        : "flex-column"
                                }
                            >
                                <label className="form-labels">
                                    Documentations : <span className="required">*</span>
                                </label>
                                <label
                                    className="form-input-doc full-width-form"
                                    htmlFor="uploaded_file"
                                >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">
                                        {/* {selectedFile ? selectedFile.name : "Select File"} */}
                                    </span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    // onChange={handleInputChange}
                                    style={{ display: "none" }}
                                />

                                {errors.length > 0 && (
                                    <span className="error-message">{errors.length}</span>
                                )}
                            </div>

                        </div>



                        <div className="button-models-add">
                            <button onClick={handleTaskSubmit} className="model-button-add">Add</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>

                    </form>

                </Modal.Body>
            </Modal>

        </>
    )
};

const SubTaskModal = ({ subActivity }) => {
    const [data] = useState([
        { id: 1, name: 'Ansh', age: 25 },
        { id: 2, name: 'Rohan', age: 30 },
        { id: 3, name: 'Archish', age: 28 },
    ]);

    const [showMainModal, setShowMainModal] = useState(false);
    const [showRowModal, setShowRowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleMainClose = () => setShowMainModal(false);
    const handleRowClose = () => {
        setShowRowModal(false);
        setSelectedRow(null);
    };

    const handleRowClick = (item) => {
        setSelectedRow(item);
        setShowRowModal(true);
    };

    return (
        <>
            <button
                title="ViewClient POS Sub-Activity"
                className="common-button"
                onClick={() => setShowMainModal(true)}
            >
                View
            </button>

            {/* Main Modal with Table */}
            <Modal show={showMainModal} onHide={handleMainClose} dialogClassName="Activity-model">
                <ModalHeader closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">

                    <h4 className="heading-name">Sub-Activity:-{subActivity.activity_name}</h4>

                </ModalHeader>
                <ModalBody>
                    <table className="Pro-details">
                        <thead>
                            <tr>
                                <th>Sub-Activity Name</th>
                                <th>Description</th>
                                <th>Weightage</th>
                                <th>Assign To</th>
                                <th>Start date</th>
                                <th>Sbumission date</th>
                                <th>Status</th>
                                <th>Documentation</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item) => (
                                <tr key={item.id}>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td>
                                        <button onClick={() => handleRowClick(item)}>View</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ModalBody>
            </Modal>

            {/* Row Detail Modal */}
            <Modal show={showRowModal} onHide={handleRowClose}>
                <ModalHeader closeButton>

                </ModalHeader>
                <ModalBody>
                    {selectedRow && (
                        <>
                            <p><strong>Name:</strong> {selectedRow.name}</p>
                            <p><strong>Age:</strong> {selectedRow.age}</p>
                            <button onClick={handleRowClose}>Close</button>
                        </>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
};

const SubActivityModal = ({ subActivity }) => {
    const [data] = useState([
        { id: 1, name: 'Ansh', age: 25 },
        { id: 2, name: 'Rohan', age: 30 },
        { id: 3, name: 'Archish', age: 28 },
    ]);

    const [showMainModal, setShowMainModal] = useState(false);
    const [showRowModal, setShowRowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleMainClose = () => setShowMainModal(false);
    const handleRowClose = () => {
        setShowRowModal(false);
        setSelectedRow(null);
    };

    const handleRowClick = (item) => {
        setSelectedRow(item);
        setShowRowModal(true);
    };

    return (
        <>
            <button
                title="ViewClient POS Sub-Activity"
                className="common-button"
                onClick={() => setShowMainModal(true)}
            >
                View
            </button>

            {/* Main Modal with Table */}
            <Modal show={showMainModal} onHide={handleMainClose} dialogClassName="Activity-model">
                <ModalHeader closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">

                    <h4 className="heading-name">Sub-Activity:-{subActivity.activity_name}</h4>

                </ModalHeader>
                <ModalBody>
                    <table className="Pro-details">
                        <thead>
                            <tr>
                                <th>Sub-Activity Name</th>
                                <th>Description</th>
                                <th>Weightage</th>
                                <th>Assign To</th>
                                <th>Start date</th>
                                <th>Sbumission date</th>
                                <th>Status</th>
                                <th>Documentation</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item) => (
                                <tr key={item.id}>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td className="personal-detail-1 font-weight500 font-size-text"></td>
                                    <td>
                                        <button onClick={() => handleRowClick(item)}>View</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ModalBody>
            </Modal>

            {/* Row Detail Modal */}
            <Modal show={showRowModal} onHide={handleRowClose}>
                <ModalHeader closeButton>

                </ModalHeader>
                <ModalBody>
                    {selectedRow && (
                        <>
                            <p><strong>Name:</strong> {selectedRow.name}</p>
                            <p><strong>Age:</strong> {selectedRow.age}</p>
                            <button onClick={handleRowClose}>Close</button>
                        </>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
};

// AddMOM.jsx
const AddMOM = ({ projectID, getMOMList }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);

    const [formData, setFormData] = useState({
        description: "",
        status: "pending",
        meeting_date: "",
        location: "",
        attendees: [],
        project: projectID,
        assignments: [{ point: "", assigned_to: "" }],
        mode_of_meeting: "",
        assigned_by: [],
    });

    const [errors, setErrors] = useState({});

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' }
    ];

    const moodOptions = [
        { value: 'offline', label: 'Offline' },
        { value: 'online', label: 'Online' },

    ];

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setFormData({
            description: "",
            status: "pending",
            meeting_date: "",
            location: "",
            attendees: [],
            project: projectID,
            assignments: [{ point: "", assigned_to: "" }]
        });
        setErrors({});
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (value) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const handlePointChange = (index, field, value) => {
        const updatedPoints = [...formData.assignments];
        updatedPoints[index][field] = value;
        setFormData(prev => ({ ...prev, assignments: updatedPoints }));
    };

    const handleSelectChange = (selected, field) => {
        setFormData(prev => ({
            ...prev,
            [field]: selected ? selected.map(item => item.value) : []
        }));
    };

    const handlePointSelect = (selected, index) => {
        const updatedPoints = [...formData.assignments];
        updatedPoints[index].assigned_to = selected ? selected.value : "";
        setFormData(prev => ({ ...prev, assignments: updatedPoints }));
    };

    //   const selectAssignBy = (selected) => {
    //     console.log("selected--->", selected);
    //     const assigned_by = selected?.value || '';
    //     setFormData(prev => ({
    //         ...prev,
    //         assigned_by
    //     }));
    // };

    const selectAssignBy = (selected) => {
        console.log("selected--->", selected);
        const assigned_by = selected ? [selected.value] : [];
        setFormData(prev => ({
            ...prev,
            assigned_by
        }));
    };


    const addPoint = () => {
        setFormData(prev => ({
            ...prev,
            assignments: [...prev.assignments, { point: "", assigned_to: "" }]
        }));
    };

    const removePoint = (index) => {
        if (formData.assignments.length <= 1) return;
        const updatedPoints = formData.assignments.filter((_, i) => i !== index);
        setFormData(prev => ({ ...prev, assignments: updatedPoints }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.description) newErrors.description = "Description is required";
        if (!formData.meeting_date) newErrors.meeting_date = "Meeting date is required";
        if (!formData.location) newErrors.location = "Location is required";

        formData.assignments.forEach((point, index) => {
            if (!point.point) newErrors[`point_${index}`] = "Point description is required";
            if (!point.assigned_to) newErrors[`assigned_${index}`] = "Assignee is required";
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const fetchDropdownData = async () => {
        try {
            const employeesRes = await axios.get(`${BASE_URL}/manpower/employee/`);
            setEmployees(employeesRes.data);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        if (show) fetchDropdownData();
    }, [show]);

    const employeeOptions = employees.map(e => ({
        value: e.id,
        label: `${e.emp_code ? e.emp_code + ' - ' : ''}${e.name}`
    }));


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Creating MOM...");
        setLoading(true);

        try {
            const res = await axios.post(`${BASE_URL}/project_details/mom/`, formData);

            if (res.status === 200 || res.status === 201) {
                handleClose();
                await getMOMList();
                toast.success("MOM created successfully!");
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to create MOM");
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Add MOM"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> MOM
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Add Minutes of Meeting</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form>
                        <div className='form-flex-wrap'>
                            {/* Description */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Description <span className="required">*</span></label>
                                <textarea
                                    placeholder="Meeting description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    className={`form-textarea  ${errors.description ? 'error' : ''}`}
                                    rows="3"
                                />
                                {errors.description && <span className="error-message">{errors.description}</span>}
                            </div>

                            {/* Meeting Date */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Meeting Date & Time <span className="required">*</span></label>
                                <input
                                    type="datetime-local"
                                    name="meeting_date"
                                    value={formData.meeting_date}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.meeting_date ? 'error' : ''}`}
                                />
                                {errors.meeting_date && <span className="error-message">{errors.meeting_date}</span>}
                            </div>

                            {/* Location */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Location <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Meeting location"
                                    name="location"
                                    value={formData.location}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.location ? 'error' : ''}`}
                                />
                                {errors.location && <span className="error-message">{errors.location}</span>}
                            </div>

                            {/* Attendees */}
                            <div className="flex-column">
                                <label className="form-labels">Attendees</label>
                                <Select
                                    options={employeeOptions}
                                    isMulti
                                    onChange={(selected) => handleSelectChange(selected, 'attendees')}
                                    value={employeeOptions.filter(opt => formData.attendees.includes(opt.value))}
                                    styles={CSSForSelect}
                                    placeholder="Select Attendees"
                                />
                            </div>

                            {/* {formData?.assigned_by?.map((point, index) => (
                                <div key={index} className="flex-row justify-between"> */}
                            <div className="flex-column">
                                <label className="form-labels">Assigned By</label>
                                <Select
                                    options={employeeOptions}
                                    onChange={(selected) => selectAssignBy(selected)}
                                    value={employeeOptions.find(opt => opt.id === formData.assigned_by)}
                                    styles={CSSForSelect}
                                    placeholder="Assigned By"
                                />
                            </div>

                            {/* </div>))
                            } */}

                            {/* Status */}
                            <div className="flex-column">
                                <label className="form-labels">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    {statusOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Meeting Mode</label>
                                <select
                                    name="mode_of_meeting"
                                    value={formData.mode_of_meeting}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    {moodOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>

                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Meeting Points{" "}
                                </h2>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>

                        </div>

                        <div className='flex-column'>
                            {/* Meeting Points */}
                            {formData?.assignments?.map((point, index) => (
                                <div key={index} className="flex-row justify-between">
                                    <div className="flex-column">
                                        <div>
                                            <label className="form-labels">Point {index + 1} <span className="required">*</span></label>
                                            {index > 0 && <button
                                                // className="model-button-cancel"
                                                className="remove-btn"
                                                type="button"
                                                onClick={() => removePoint(index)}
                                                title="Remove"
                                            >
                                                <CrosswithGreyCircle />
                                            </button>}
                                        </div>
                                        <input
                                            type="text"
                                            placeholder="Point description"
                                            value={point.point}
                                            onChange={(e) => handlePointChange(index, "point", e.target.value)}
                                            className={`form-input ${errors[`point_${index}`] ? 'error' : ''}`}
                                        />
                                        <div>
                                            {errors[`point_${index}`] && (
                                                <span className="error-message">{errors[`point_${index}`]}</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="flex-column ">
                                        <label className="form-labels">Assigned To <span className="required">*</span></label>
                                        <Select
                                            options={employeeOptions}
                                            onChange={(selected) => handlePointSelect(selected, index)}
                                            value={employeeOptions.find(opt => opt.value === point.assigned_to)}
                                            styles={CSSForSelect}
                                            placeholder="Select Assignee"
                                        />
                                        <div>
                                            {errors[`assigned_${index}`] && (
                                                <span className="error-message">{errors[`assigned_${index}`]}</span>
                                            )}
                                        </div>
                                    </div>

                                    {/* {formData.assignments.length > 1 && (
                                        <button
                                            type="button"
                                            onClick={() => removePoint(index)}
                                            className="model-button-cancel"
                                            style={{ marginBottom: '20px' }}
                                        >
                                            Remove Point
                                        </button>
                                    )} */}

                                </div>
                            ))}
                        </div>
                        <div className="flex-row ">
                            <button
                                type="button"
                                title="Add Points"
                                onClick={addPoint}
                                className="upload-svg"
                            >
                                Add Another Point
                            </button>
                        </div>

                        {/* </div> */}

                        <div className="button-models-add" >
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? 'Creating...' : 'Create MOM'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};



const UpdateMOM = ({ i, mom, getMOMList }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        description: "",
        status: "pending",
        meeting_date: "",
        location: "",
        attendees: [],
        project: "",
        assignments: [],
        mode_of_meeting: "",
        assigned_by: [],
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [employees, setEmployees] = useState([]);

    useEffect(() => {
        if (employees && employees.length > 0) {
            setEmployeeOptions(employees.map(emp => ({
                value: emp.id,
                label: `${emp.name} (${emp.emp_code || 'No ID'})`
            })));
        }
    }, [employees]);

    useEffect(() => {
        if (mom && show) {
            setFormData({
                description: mom.description || "",
                status: mom.status || "pending",
                meeting_date: mom.meeting_date ? mom.meeting_date.slice(0, 16) : "",
                location: mom.location || "",
                attendees: mom.attendees?.map(a => a.id) || [],
                project: mom.project?.id || "",
                assignments: mom.mom_mom?.map(a => ({
                    id: a.id,
                    point: a.points || "",
                    assigned_to: a.assigned_to?.id || "",
                    status: a.status || "pending",
                    due_date: a.due_date || "",
                    location: a.location || ""
                })) || []
            });
        }
    }, [mom, show]);

    const handleClose = () => {
        setShow(false);
        setErrors({});
    };

    const handleShow = () => setShow(true);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (value) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const handlePointChange = (index, field, value) => {
        const updatedPoints = [...formData.assignments];
        updatedPoints[index][field] = value;
        setFormData(prev => ({ ...prev, assignments: updatedPoints }));
    };

    const handleSelectChange = (selected, field) => {
        setFormData(prev => ({
            ...prev,
            [field]: selected ? selected.map(item => item.value) : []
        }));
    };

    // const handlePointSelect = (selected, index) => {
    //     const updatedPoints = [...formData.assignments];
    //     updatedPoints[index].assigned_to = selected ? selected.value : "";
    //     setFormData(prev => ({ ...prev, assignments: updatedPoints }));
    // };

    const handlePointSelect = (selected, index) => {
        const updatedPoints = [...formData.assignments];
        updatedPoints[index].assigned_to = selected ? [selected.value] : []; // ✅ always array
        setFormData(prev => ({ ...prev, assignments: updatedPoints }));
    };


    //   const selectAssignBy = (selected) => {
    //     const assigned_by = selected?.value || '';
    //     setFormData(prev => ({
    //         ...prev,
    //         assigned_by
    //     }));
    // };

    const selectAssignBy = (selected) => {
        console.log("selected--->", selected);
        const assigned_by = selected ? [selected.value] : [];
        setFormData(prev => ({
            ...prev,
            assigned_by
        }));
    };

    const addPoint = () => {
        setFormData(prev => ({
            ...prev,
            assignments: [...prev.assignments, { point: "", assigned_to: "", status: "pending" }]
        }));
    };

    const removePoint = (index) => {
        const updatedPoints = formData.assignments.filter((_, i) => i !== index);
        setFormData(prev => ({ ...prev, assignments: updatedPoints }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.description) newErrors.description = "Description is required";
        if (!formData.meeting_date) newErrors.meeting_date = "Meeting date is required";
        if (!formData.location) newErrors.location = "Location is required";

        // Validate each point
        formData.assignments.forEach((point, index) => {
            if (!point.point) newErrors[`point_${index}`] = "Point description is required";
            if (!point.assigned_to) newErrors[`assigned_${index}`] = "Assignee is required";
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const [loading, setLoading] = useState(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Updating MOM...");
        setLoading(true);

        try {
            const response = await axios.put(
                `${BASE_URL}/project_details/mom/${mom.id}/`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("response--->", response);
            if (response.status === 200) {
                handleClose();
                await getMOMList();

                toast.success("MOM updated successfully!");
            }

        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to update MOM");
            console.error(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const [employeeOptions, setEmployeeOptions] = useState([]);

    const fetchDropdownData = async () => {
        try {

            const employeesRes = await axios.get(`${BASE_URL}/manpower/employee/`);

            console.log(employeesRes)


            setEmployees(employeesRes.data);


        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        if (show) {
            fetchDropdownData()
        }
    }, [show]);

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' }
    ];


    const moodOptions = [
        { value: 'offline', label: 'Offline' },
        { value: 'online', label: 'Online' },

    ];
    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title>Update Minutes of Meeting</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className='form-flex-wrap'>
                            {/* Description */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Description <span className="required">*</span></label>
                                <textarea
                                    placeholder="Meeting description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    className={`form-textarea  ${errors.description ? 'error' : ''}`}
                                    rows="3"
                                />
                                {errors.description && <span className="error-message">{errors.description}</span>}
                            </div>

                            {/* Meeting Date */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Meeting Date & Time <span className="required">*</span></label>
                                <input
                                    type="datetime-local"
                                    name="meeting_date"
                                    value={formData.meeting_date}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.meeting_date ? 'error' : ''}`}
                                />
                                {errors.meeting_date && <span className="error-message">{errors.meeting_date}</span>}
                            </div>

                            {/* Location */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Location <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Meeting location"
                                    name="location"
                                    value={formData.location}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.location ? 'error' : ''}`}
                                />
                                {errors.location && <span className="error-message">{errors.location}</span>}
                            </div>

                            {/* Attendees */}
                            <div className="flex-column">
                                <label className="form-labels">Attendees</label>
                                <Select
                                    options={employeeOptions}
                                    isMulti
                                    onChange={(selected) => handleSelectChange(selected, 'attendees')}
                                    value={employeeOptions.filter(opt => formData.attendees.includes(opt.value))}
                                    styles={CSSForSelect}
                                    placeholder="Select Attendees"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Assigned By</label>
                                <Select
                                    options={employeeOptions}
                                    onChange={selectAssignBy}
                                    value={employeeOptions.find(opt => opt.id === formData.assigned_by)}
                                    styles={CSSForSelect}
                                    placeholder="Assigned By"
                                />
                                {/* <Select
                                    options={employeeOptions}
                                    onChange={(selected) => selectAssignBy(selected)}
                                    value={employeeOptions.find(opt => opt.id === formData.assigned_by)}
                                    styles={CSSForSelect}
                                    placeholder="Assigned By"
                                /> */}
                            </div>

                            {/* Status */}
                            <div className="flex-column">
                                <label className="form-labels">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    {statusOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Meeting Mode</label>
                                <select
                                    name="mode_of_meeting"
                                    value={formData.mode_of_meeting}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    {moodOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>

                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Meeting Points{" "}
                                </h2>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>

                        </div>

                        <div className='flex-column'>
                            {/* Meeting Points */}
                            {formData?.assignments?.map((point, index) => (
                                <div key={index} className="flex-row justify-between">
                                    <div className="flex-column">
                                        <div>
                                            <label className="form-labels">Point {index + 1} <span className="required">*</span></label>
                                            {index > 0 && <button
                                                // className="model-button-cancel"
                                                className="remove-btn"
                                                type="button"
                                                onClick={() => removePoint(index)}
                                                title="Remove"
                                            >
                                                <CrosswithGreyCircle />
                                            </button>}
                                        </div>
                                        <input
                                            type="text"
                                            placeholder="Point description"
                                            value={point.point}
                                            onChange={(e) => handlePointChange(index, "point", e.target.value)}
                                            className={`form-input ${errors[`point_${index}`] ? 'error' : ''}`}
                                        />
                                        <div>
                                            {errors[`point_${index}`] && (
                                                <span className="error-message">{errors[`point_${index}`]}</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="flex-column ">
                                        <label className="form-labels">Assigned To <span className="required">*</span></label>
                                        <Select
                                            options={employeeOptions}
                                            onChange={(selected) => handlePointSelect(selected, index)}
                                            value={employeeOptions.find(opt => opt.value === point.assigned_to)}
                                            styles={CSSForSelect}
                                            placeholder="Select Assignee"
                                        />
                                        <div>
                                            {errors[`assigned_${index}`] && (
                                                <span className="error-message">{errors[`assigned_${index}`]}</span>
                                            )}
                                        </div>
                                    </div>

                                    {/* {formData.assignments.length > 1 && (
                                        <button
                                            type="button"
                                            onClick={() => removePoint(index)}
                                            className="model-button-cancel"
                                            style={{ marginBottom: '20px' }}
                                        >
                                            Remove Point
                                        </button>
                                    )} */}

                                </div>
                            ))}
                        </div>
                        <div className="flex-row ">
                            <button
                                type="button"
                                title="Add Points"
                                onClick={addPoint}
                                className="upload-svg"
                            >
                                Add Another Point
                            </button>
                        </div>

                        <div className="button-models-add">
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleFormSubmit}
                            >
                                {loading ? 'Updateing...' : 'Update MOM'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};



const DeleteMOM = ({ mom, getMOMList }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const response = await axios.delete(`${BASE_URL}/project_details/mom/${mom.id}/`);
            if (response.status === 204) {
                setShow(false);
                await getMOMList();
                toast.success("MOM deleted successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Minutes of Meeting</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are you sure you want to delete this MOM record?
                        <div className="button-models">
                            <button className="model-button font-weight500 model-button-cancel" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button font-weight500 model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};


const AddTaskActivity = ({ taskID, taskActivities, getActivityList, employees, vendors, approvalTeams }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        task: taskID,
        parent_activity: null,
        vendor: null,
        assigned_by: null,
        assigned_to: [],
        status: "pending",
        approving_team: null,
        approval_remarks: "",
        assign_date: new Date().toISOString().split('T')[0],
        deadline_date: "",
        overdue_reason: "",
        start_date: "",
        end_date: "",
        unit: "",
        scope_quantity: "",
        completed_till_end: "",
        target_of_month: "",
        achieved_this_month: "",
        shortfall_excess_in_month: "",
        remarks: "",
        weightage: "",
        uploaded_file: null
    });

    const handleClose = () => {
        setFormData({
            name: "",
            task: taskID,
            parent_activity: null,
            vendor: null,
            assigned_by: null,
            assigned_to: [],
            status: "pending",
            approving_team: null,
            approval_remarks: "",
            assign_date: new Date().toISOString().split('T')[0],
            deadline_date: "",
            overdue_reason: "",
            start_date: "",
            end_date: "",
            unit: "",
            scope_quantity: "",
            completed_till_end: "",
            target_of_month: "",
            achieved_this_month: "",
            shortfall_excess_in_month: "",
            remarks: "",
            weightage: "",
            uploaded_file: null
        });
        setErrors({});
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "name",
            "assigned_by",
            "assigned_to",
            "deadline_date",
            "start_date",
            "end_date",
            "unit",
            "scope_quantity",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' ')} is required`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked, files, options } = e.target;

        let newValue;
        if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files[0];
        } else if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter(option => option.selected)
                .map(option => option.value);
        } else {
            newValue = value;
        }

        // Update form data
        const updatedFormData = {
            ...formData,
            [name]: newValue
        };

        // Auto-calculate shortfall/excess when target or achieved values change
        if (name === "target_of_month" || name === "achieved_this_month") {
            const target = parseFloat(updatedFormData.target_of_month) || 0;
            const achieved = parseFloat(updatedFormData.achieved_this_month) || 0;

            const ratio = target !== 0 ? (achieved / target) : 0;

            updatedFormData.shortfall_excess_in_month = ratio.toFixed(4);
        }

        setFormData(updatedFormData);

        if (value) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const handleFileChange = (e) => {
        const { name, value } = e.target;
        const file = e.target.files[0];

        if (file) {
            setFormData({ ...formData, [name]: file, });
        } else {
            //   console.log('no file')
        }

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }

    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Saving activity...");

        try {
            const formDataToSend = new FormData();

            // Append all fields to formData
            Object.keys(formData).forEach(key => {
                if (key === "assigned_to") {
                    const assigned = formData[key];
                    if (Array.isArray(assigned)) {
                        assigned.forEach(id => formDataToSend.append(key, id));
                    } else if (assigned !== null && assigned !== "") {
                        formDataToSend.append(key, assigned);
                    }
                } else if (formData[key] !== null && formData[key] !== "") {
                    formDataToSend.append(key, formData[key]);
                }
            });


            formDataToSend.append("task", taskID);
            // formDataToSend.append("task", taskID);

            const res = await axios.post(
                `${BASE_URL}/project_details/activity/`,
                formDataToSend,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (res.status === 201) {
                toast.success("Activity created successfully");
                handleClose();
                await getActivityList();
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };
    const options = employees
        .sort((a, b) => parseInt(a.name) - parseInt(b.name))
        .map((e) => ({
            value: e.id,
            label: `${e.emp_role} - ${e.name}`,
        }));

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const assigned_to = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            assigned_to,
        }));
    };
    return (
        <>
            <button title="Add Activity" className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle /> Add Activity
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton className="justify-center task-Tab-heading">
                    <Modal.Title>Add New Activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="activity-form">
                        <div className="form-flex-wrap">
                            {/* Basic Information */}
                            <div className="flex-column">
                                <label className="form-labels">Activity Name<span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.name ? "error" : ""}`}
                                    placeholder="Enter activity name"
                                />
                                {errors.name && <span className="error-message">{errors.name}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Parent Activity</label>
                                <select
                                    name="parent_activity"
                                    value={formData.parent_activity || ""}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select Parent Activity</option>
                                    {taskActivities?.map(act => (
                                        <option key={act.id} value={act.id}>
                                            {act.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Assignment Section */}
                            <div className="flex-column">
                                <label className="form-labels">Assigned By<span className="required">*</span></label>
                                <select
                                    name="assigned_by"
                                    value={formData.assigned_by || ""}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.assigned_by ? "error" : ""}`}
                                >
                                    <option value="">Select an Assigner</option>
                                    {employees?.map(emp => (
                                        <option key={emp.id} value={emp.id}>
                                            {emp.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.assigned_by && <span className="error-message">{errors.assigned_by}</span>}
                            </div>




                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assigned To:<span className="required">*</span>
                                </label>

                                <Select
                                    options={options}
                                    isMulti
                                    onChange={selectEmployee}
                                    value={formData.assigned_to?.map((code) => ({
                                        value: code,
                                        label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={CSSForSelect}

                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>


                            <div className="flex-column">
                                <label className="form-labels">Vendor</label>
                                <select
                                    name="vendor"
                                    value={formData.vendor || ""}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select Vendor</option>
                                    {vendors?.map(vendor => (
                                        <option key={vendor.id} value={vendor.id}>
                                            {vendor.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Dates Section */}

                            <div className="flex-column">
                                <label className="form-labels">Deadline Date<span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="deadline_date"
                                    value={formData.deadline_date}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.deadline_date ? "error" : ""}`}
                                />
                                {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Start Date<span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="start_date"
                                    value={formData.start_date}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">End Date<span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="end_date"
                                    value={formData.end_date}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            {/* Approval Section */}
                            <div className="flex-column">
                                <label className="form-labels">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Approving Team</label>
                                <select
                                    name="approving_team"
                                    value={formData.approving_team || ""}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select Approval Team</option>
                                    {approvalTeams?.map(team => (
                                        <option key={team.id} value={team.id}>
                                            {team.approval_source}-{team.external_approval}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Unit<span className="required">*</span></label>
                                <select
                                    name="unit"
                                    value={formData.unit || ""}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select a Unit</option>
                                    <option value="Nos">Nos</option>
                                    <option value="Sqm">Sqm</option>
                                    <option value="Rm">Rm</option>
                                    <option value="Km">Km</option>
                                    <option value="MT">MT</option>
                                </select>
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Scope Quantity<span className="required">*</span></label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="scope_quantity"
                                    value={formData.scope_quantity}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="0.0000"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Completed Till End</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="completed_till_end"
                                    value={formData.completed_till_end}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="0.0000"
                                />
                            </div>

                            {/* Monthly Targets */}
                            <div className="flex-column">
                                <label className="form-labels">Target of Month</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="target_of_month"
                                    value={formData.target_of_month}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="0.0000"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Achieved This Month</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="achieved_this_month"
                                    value={formData.achieved_this_month}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Shortfall/Excess in Month<span className="required">(Auto)</span></label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="shortfall_excess_in_month"
                                    value={formData.shortfall_excess_in_month}
                                    style={{ cursor: 'not-allowed' }}
                                    className="form-input"
                                    disabled
                                    placeholder="Auto-calculated"
                                />
                            </div>

                            {/* Other Fields */}
                            <div className="flex-column">
                                <label className="form-labels">Remarks</label>
                                <textarea
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="Enter any additional remarks"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Weightage</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    min="0"
                                    max="1"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="0.0000 to 1.0000"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Upload File</label>
                                <div
                                    className={`file-upload-container flex-row justify-between form-input ${errors.uploaded_file ? 'error' : formData.uploaded_file ? 'success' : ''}`}
                                >
                                    <label
                                        className={`file-label ${errors.uploaded_file ? 'error' : ''}`}
                                    >
                                        <input
                                            type="file"
                                            name="uploaded_file"
                                            onChange={handleFileChange}
                                            className={`file-input`}
                                            style={{ display: "none" }}
                                        />
                                        <CloudUpload />{" "}
                                        <span>
                                            {formData.uploaded_file ? formData.uploaded_file.name : 'No file selected'}
                                        </span>
                                    </label>
                                    {formData.uploaded_file && (
                                        <span
                                            className="file-clear"
                                            onClick={(e) => handleFileClear('uploaded_file')}
                                        >
                                            Clear
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="button-models">
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button model-button-cancel"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                onClick={handleSubmit}
                                className="model-button model-button-submit"
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Save Activity"}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal >
        </>
    );
};

const UpdateTaskActivity = ({ taskID, activity, taskActivities, getActivityList, employees, vendors, approvalTeams }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({ ...activity });
    const [originalFile, setOriginalFile] = useState(activity.uploaded_file);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setFormData({ ...activity });
        setOriginalFile(activity.uploaded_file);
        setShow(true);
    };

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "name",
            "assigned_by",
            "assigned_to",
            "deadline_date",
            "start_date",
            "end_date",
            "unit",
            "scope_quantity",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' ')} is required`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked, files, options } = e.target;

        let newValue;
        if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files[0];
        } else if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter(option => option.selected)
                .map(option => option.value);
        } else {
            newValue = value;
        }

        // Update form data
        const updatedFormData = {
            ...formData,
            [name]: newValue
        };

        // Auto-calculate shortfall/excess when target or achieved values change
        if (name === "target_of_month" || name === "achieved_this_month") {
            const target = parseFloat(updatedFormData.target_of_month) || 0;
            const achieved = parseFloat(updatedFormData.achieved_this_month) || 0;

            const ratio = target !== 0 ? (achieved / target) : 0;

            updatedFormData.shortfall_excess_in_month = ratio.toFixed(4);
        }

        setFormData(updatedFormData);

        if (value) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const handleFileChange = (e) => {
        const { name, value } = e.target;
        const file = e.target.files[0];

        if (file) {
            setFormData({ ...formData, [name]: file, });
        } else {
            //   console.log('no file')
        }

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }

    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Updating activity...");

        try {
            const formDataToSend = new FormData();

            // Append all fields to formData
            Object.keys(formData).forEach(key => {
                if (key === "assigned_to") {
                    const assigned = formData[key];
                    if (Array.isArray(assigned)) {
                        assigned.forEach(id => formDataToSend.append(key, id));
                    } else if (assigned !== null && assigned !== "") {
                        formDataToSend.append(key, assigned);
                    }
                } else if (formData[key] !== null && formData[key] !== "") {
                    formDataToSend.append(key, formData[key]);
                }
            });

            // formDataToSend.append("task", taskID);

            // Only send file if it's changed
            if (formData.uploaded_file && formData.uploaded_file !== originalFile) {
                formDataToSend.append("uploaded_file", formData.uploaded_file);
            }

            const res = await axios.put(
                `${BASE_URL}/project_details/activity/${formData.id}/`,
                formDataToSend,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (res.status === 200) {
                toast.success("Activity updated successfully");
                handleClose();
                await getActivityList();
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const options = employees
        .sort((a, b) => parseInt(a.name) - parseInt(b.name))
        .map((e) => ({
            value: e.id,
            label: `${e.emp_role} - ${e.name}`,
        }));

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const assigned_to = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            assigned_to,
        }));
    };

    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton className="justify-center task-Tab-heading">
                    <Modal.Title>Update Activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="activity-form">
                        <div className="form-flex-wrap">
                            {/* Basic Information */}
                            <div className="flex-column">
                                <label className="form-labels">Activity Name<span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.name ? "error" : ""}`}
                                    placeholder="Enter activity name"
                                />
                                {errors.name && <span className="error-message">{errors.name}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Parent Activity</label>
                                <select
                                    name="parent_activity"
                                    value={formData.parent_activity || ""}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select Parent Activity</option>
                                    {taskActivities?.map(act => (
                                        <option key={act.id} value={act.id}>
                                            {act.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Assignment Section */}
                            <div className="flex-column">
                                <label className="form-labels">Assigned By<span className="required">*</span></label>
                                <select
                                    name="assigned_by"
                                    value={formData.assigned_by || ""}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.assigned_by ? "error" : ""}`}
                                >
                                    <option value="">Select an Assigner</option>
                                    {employees?.map(emp => (
                                        <option key={emp.id} value={emp.id}>
                                            {emp.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.assigned_by && <span className="error-message">{errors.assigned_by}</span>}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assigned To:<span className="required">*</span>
                                </label>

                                <Select
                                    options={options}
                                    isMulti
                                    onChange={selectEmployee}
                                    value={formData.assigned_to?.map((code) => ({
                                        value: code,
                                        label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Vendor</label>
                                <select
                                    name="vendor"
                                    value={formData.vendor || ""}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select Vendor</option>
                                    {vendors?.map(vendor => (
                                        <option key={vendor.id} value={vendor.id}>
                                            {vendor.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Dates Section */}

                            <div className="flex-column">
                                <label className="form-labels">Deadline Date<span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="deadline_date"
                                    value={formData.deadline_date}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.deadline_date ? "error" : ""}`}
                                />
                                {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Start Date<span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="start_date"
                                    value={formData.start_date}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">End Date<span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="end_date"
                                    value={formData.end_date}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            {/* Approval Section */}
                            <div className="flex-column">
                                <label className="form-labels">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Approving Team</label>
                                <select
                                    name="approving_team"
                                    value={formData.approving_team || ""}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select Approval Team</option>
                                    {approvalTeams?.map(team => (
                                        <option key={team.id} value={team.id}>
                                            {team.approval_source}-{team.external_approval}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Unit<span className="required">*</span></label>
                                <select
                                    name="unit"
                                    value={formData.unit || ""}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select a Unit</option>
                                    <option value="Nos">Nos</option>
                                    <option value="Sqm">Sqm</option>
                                    <option value="Rm">Rm</option>
                                    <option value="Km">Km</option>
                                    <option value="MT">MT</option>
                                </select>
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Scope Quantity<span className="required">*</span></label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="scope_quantity"
                                    value={formData.scope_quantity}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="0.0000"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Completed Till End</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="completed_till_end"
                                    value={formData.completed_till_end}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="0.0000"
                                />
                            </div>

                            {/* Monthly Targets */}
                            <div className="flex-column">
                                <label className="form-labels">Target of Month</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="target_of_month"
                                    value={formData.target_of_month}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="0.0000"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Achieved This Month</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="achieved_this_month"
                                    value={formData.achieved_this_month}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Shortfall/Excess in Month<span className="required">(Auto)</span></label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    name="shortfall_excess_in_month"
                                    value={formData.shortfall_excess_in_month}
                                    style={{ cursor: 'not-allowed' }}
                                    className="form-input"
                                    disabled
                                    placeholder="Auto-calculated"
                                />
                            </div>

                            {/* Other Fields */}
                            <div className="flex-column">
                                <label className="form-labels">Remarks</label>
                                <textarea
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="Enter any additional remarks"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Weightage</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    min="0"
                                    max="1"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="0.0000 to 1.0000"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Upload File</label>
                                <div
                                    className={`file-upload-container flex-row justify-between form-input ${errors.uploaded_file ? 'error' : formData.uploaded_file ? 'success' : ''}`}
                                >
                                    <label
                                        className={`file-label ${errors.uploaded_file ? 'error' : ''}`}
                                    >
                                        <input
                                            type="file"
                                            name="uploaded_file"
                                            onChange={handleFileChange}
                                            className={`file-input`}
                                            style={{ display: "none" }}
                                        />
                                        <CloudUpload />{" "}
                                        <span>
                                            {formData.uploaded_file ? formData.uploaded_file.name : 'No file selected'}
                                        </span>
                                    </label>
                                    {formData.uploaded_file && (
                                        <span
                                            className="file-clear"
                                            onClick={(e) => handleFileClear('uploaded_file')}
                                        >
                                            Clear
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="button-models">
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button model-button-cancel"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                onClick={handleSubmit}
                                className="model-button model-button-submit"
                                disabled={loading}
                            >
                                {loading ? "Updating..." : "Update Activity"}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteTaskActivity = ({ activity, getActivityList }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Deleting activity...");

        try {
            const res = await axios.delete(`${BASE_URL}/project_details/activity/${activity.id}/`);

            if (res.status === 200) {
                toast.success("Activity deleted successfully");
                handleClose();
                await getActivityList();
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are you sure you want to delete the Activity "{activity.name}"?
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const AddROB = ({ projectID, getROBList, department_name }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [robs, setRobs] = useState([]);

    const [formData, setFormData] = useState({
        activity: '',
        status_yesterday: '',
        status_today: '',
        target_this_week: '',
        action_to_be_taken: '',
        parent_rob: '',
        remarks: '',
        tasks: '',
        status: 'pending',
        reason_for_pending: '',
        target_for_this_month: "",
    });

    const [errors, setErrors] = useState({});

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'inprogress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
    ];

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setFormData({
            activity: '',
            status_yesterday: '',
            status_today: '',
            target_this_week: '',
            action_to_be_taken: '',
            parent_rob: '',
            remarks: '',
            tasks: '',
            status: 'pending',
        });
        setErrors({});
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.activity) newErrors.activity = 'Activity is required';
        if (!formData.status_today) newErrors.status_today = "Today's status is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);

        try {
            const res = await axios.post(`${BASE_URL}/project_details/rob/`, formData);
            if (res.status === 200 || res.status === 201) {
                handleClose();
                await getROBList();
                toast.success("ROB added successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (value.trim()) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const fetchDropdownData = async () => {
        try {
            const [employeesRes, tasksRes, robsRes] = await Promise.all([
                axios.get(`${BASE_URL}/manpower/employee/`),
                axios.get(`${BASE_URL}/project_details/task/`),
                axios.get(`${BASE_URL}/project_details/rob/`)
            ]);

            setEmployees(employeesRes.data);
            setTasks(tasksRes.data);
            setRobs(robsRes.data);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        if (show) fetchDropdownData();
    }, [show]);

    const employeeOptions = employees.map(e => ({
        value: e.id,
        label: `${e.emp_code ? e.emp_code + ' - ' : ''}${e.name}`
    }));

    const taskOptions = tasks.map(t => ({
        value: t.id,
        label: t.task_name
    }));

    const robOptions = robs.map(r => ({
        value: r.id,
        label: r.activity || `ROB-${r.id.substring(0, 8)}`
    }));

    return (
        <>
            <button
                title="Add ROB"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> ROB
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Add Report of the Day</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            {/* Activity */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Activity <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Describe the activity"
                                    name="activity"
                                    value={formData.activity}
                                    onChange={handleInputChange}
                                    className="form-input"

                                />
                                {errors.activity && <span className="error-message">{errors.activity}</span>}
                            </div>

                            {/* Status Yesterday */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Yesterday's Status</label>
                                <input
                                    type="text"
                                    placeholder="Status yesterday"
                                    name="status_yesterday"
                                    value={formData.status_yesterday}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>



                            {/* Status Today */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Today's Status <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="status_today"
                                    value={formData.status_today}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="Yesterday Today"
                                />
                                {errors.status_today && <span className="error-message">{errors.status_today}</span>}
                            </div>

                            {/* Target This Week */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Target This Week</label>
                                <textarea
                                    type="text"
                                    placeholder="Target for this week"
                                    name="target_this_week"
                                    value={formData.target_this_week}
                                    onChange={handleInputChange}
                                    className="form-textarea"

                                />
                            </div>

                            <div className="flex-column full-width-form">
                                <label className="form-labels">Target For This Month</label>
                                <textarea
                                    type="text"
                                    placeholder="Target for this Month"
                                    name="target_for_this_month"
                                    value={formData.target_for_this_month}
                                    onChange={handleInputChange}
                                    className="form-textarea"

                                />
                            </div>

                            <div className="flex-column full-width-form">
                                <label className="form-labels">Reason For Pending</label>
                                <textarea
                                    type="text"
                                    placeholder="Reason for Pending"
                                    name="reason_for_pending"
                                    value={formData.reason_for_pending}
                                    onChange={handleInputChange}
                                    className="form-textarea"

                                />
                            </div>

                            {/* Action To Be Taken */}
                            <div className="flex-column">
                                <label className="form-labels">Action To Be Taken</label>
                                <Select
                                    options={employeeOptions}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            action_to_be_taken: selected?.value || ''
                                        }))
                                    }
                                    styles={CSSForSelect}
                                    placeholder="Select Employee"
                                />
                            </div>

                            {/* Parent ROB */}
                            <div className="flex-column">
                                <label className="form-labels">Parent ROB</label>
                                <Select
                                    options={robOptions}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            parent_rob: selected?.value || ''
                                        }))
                                    }
                                    styles={CSSForSelect}
                                    placeholder="Select Parent ROB"
                                />
                            </div>

                            {/* Task */}
                            <div className="flex-column">
                                <label className="form-labels">Related Task</label>
                                <Select
                                    options={taskOptions}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            tasks: selected?.value || ''
                                        }))
                                    }
                                    styles={CSSForSelect}
                                    placeholder="Select Task"
                                />
                            </div>

                            {/* Status */}
                            <div className="flex-column">
                                <label className="form-labels">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    {statusOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Remarks */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Remarks</label>
                                <input
                                    type="text"
                                    placeholder="Additional remarks"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                    className="form-input"

                                />
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? 'Adding...' : 'Add'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateROB = ({ rob, getROBList, department_name }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [robs, setRobs] = useState([]);

    const [formData, setFormData] = useState({
        activity: rob.activity || '',
        status_yesterday: rob.status_yesterday || '',
        status_today: rob.status_today || '',
        target_this_week: rob.target_this_week || '',
        action_to_be_taken: rob.action_to_be_taken?.id || '',
        parent_rob: rob.parent_rob?.id || '',
        remarks: rob.remarks || '',
        tasks: rob.tasks?.id || '',
        status: rob.status || 'pending',
        reason_for_pending: rob?.reason_for_pending || '',
        target_for_this_month: rob?.target_for_this_month || ""
    });

    const [errors, setErrors] = useState({});

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'inprogress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
    ];

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setFormData({
            activity: rob.activity || '',
            status_yesterday: rob.status_yesterday || '',
            status_today: rob.status_today || '',
            target_this_week: rob.target_this_week || '',
            action_to_be_taken: rob.action_to_be_taken?.id || '',
            parent_rob: rob.parent_rob?.id || '',
            remarks: rob.remarks || '',
            tasks: rob.tasks?.id || '',
            status: rob.status || 'pending',
        });
        setErrors({});
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.activity) newErrors.activity = 'Activity is required';
        if (!formData.status_today) newErrors.status_today = "Today's status is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);

        try {
            const res = await axios.put(`${BASE_URL}/project_details/rob/${rob.id}/`, formData);
            if (res.status === 200 || res.status === 201) {
                handleClose();
                await getROBList();
                toast.success("ROB updated successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (value.trim()) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const fetchDropdownData = async () => {
        try {
            const [employeesRes, tasksRes, robsRes] = await Promise.all([
                axios.get(`${BASE_URL}/manpower/employee/`),
                axios.get(`${BASE_URL}/project_details/task/`),
                axios.get(`${BASE_URL}/project_details/rob/`)
            ]);

            setEmployees(employeesRes.data);
            setTasks(tasksRes.data);
            setRobs(robsRes.data);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        if (show) fetchDropdownData();
    }, [show]);

    const employeeOptions = employees.map(e => ({
        value: e.id,
        label: `${e.emp_code ? e.emp_code + ' - ' : ''}${e.name}`
    }));

    const taskOptions = tasks.map(t => ({
        value: t.id,
        label: t.task_name
    }));

    const robOptions = robs.map(r => ({
        value: r.id,
        label: r.activity || `ROB-${r.id.substring(0, 8)}`
    }));

    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Update Report of the Day</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            {/* Activity */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Activity <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Describe the activity"
                                    name="activity"
                                    value={formData.activity}
                                    onChange={handleInputChange}
                                    className="form-input"

                                />
                                {errors.activity && <span className="error-message">{errors.activity}</span>}
                            </div>

                            {/* Status Yesterday */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Yesterday's Status</label>
                                <input
                                    type="text"
                                    placeholder="Status yesterday"
                                    name="status_yesterday"
                                    value={formData.status_yesterday}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            {/* Status Today */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Today's Status <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="status_today"
                                    value={formData.status_today}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="Yesterday Today"
                                />
                                {errors.status_today && <span className="error-message">{errors.status_today}</span>}
                            </div>

                            {/* Target This Week */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Target This Week</label>
                                <textarea
                                    type="text"
                                    placeholder="Target for this week"
                                    name="target_this_week"
                                    value={formData.target_this_week}
                                    onChange={handleInputChange}
                                    className="form-textarea"

                                />
                            </div>

                            <div className="flex-column full-width-form">
                                <label className="form-labels">Target For This Month</label>
                                <textarea
                                    type="text"
                                    placeholder="Target for this Month"
                                    name="target_for_this_month"
                                    value={formData.target_for_this_month}
                                    onChange={handleInputChange}
                                    className="form-textarea"

                                />
                            </div>

                            <div className="flex-column full-width-form">
                                <label className="form-labels">Reason For Pending</label>
                                <textarea
                                    type="text"
                                    placeholder="Reason for Pending"
                                    name="reason_for_pending"
                                    value={formData.reason_for_pending}
                                    onChange={handleInputChange}
                                    className="form-textarea"

                                />
                            </div>

                            {/* Action To Be Taken */}
                            <div className="flex-column">
                                <label className="form-labels">Action To Be Taken</label>
                                <Select
                                    options={employeeOptions}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            action_to_be_taken: selected?.value || ''
                                        }))
                                    }
                                    styles={CSSForSelect}
                                    placeholder="Select Employee"
                                />
                            </div>

                            {/* Parent ROB */}
                            <div className="flex-column">
                                <label className="form-labels">Parent ROB</label>
                                <Select
                                    options={robOptions}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            parent_rob: selected?.value || ''
                                        }))
                                    }
                                    styles={CSSForSelect}
                                    placeholder="Select Parent ROB"
                                />
                            </div>

                            {/* Task */}
                            <div className="flex-column">
                                <label className="form-labels">Related Task</label>
                                <Select
                                    options={taskOptions}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            tasks: selected?.value || ''
                                        }))
                                    }
                                    styles={CSSForSelect}
                                    placeholder="Select Task"
                                />
                            </div>

                            {/* Status */}
                            <div className="flex-column">
                                <label className="form-labels">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    {statusOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Remarks */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Remarks</label>
                                <input
                                    type="text"
                                    placeholder="Additional remarks"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                    className="form-input"

                                />
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? 'Updating...' : 'Update'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteROB = ({ rob, getROBList }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleDelete = async () => {
        const loadingToastId = toast.loading("Deleting...");
        setLoading(true);
        try {
            const res = await axios.delete(`${BASE_URL}/project_details/rob/${rob.id}/`);
            if (res.status === 204) {
                handleClose();
                await getROBList();
                toast.success("ROB deleted successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this ROB?
                    <br />
                    <strong>{rob.activity || `ROB-${rob.id.substring(0, 8)}`}</strong>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="model-button-cancel"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className="model-button-delete"
                        onClick={handleDelete}
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

const AddMaterial = ({ projectID, getMaterialList, department_name }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [materials, setMaterials] = useState([]);

    const [formData, setFormData] = useState({
        task: '',
        parent_material: '',
        item_description: '',
        unit: '',
        project_scope_quantity: '',
        upto_date_received: '',
        balance_to_be_procure: '',
        received_upto_previous_day: '',
        issued_upto_date: '',
        stock_as_on_date: '',
        issued_upto: '',
        stock_as_on: '',
        received_today: '',
        received_this_month: '',
        remarks: '',
        status: 'pending',
    });

    const [errors, setErrors] = useState({});

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'inprogress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
    ];

    const unitOptions = [
        { value: 'kg', label: 'Kilogram' },
        { value: 'm', label: 'Meter' },
        { value: 'l', label: 'Liter' },
        { value: 'pc', label: 'Piece' },
        { value: 'ton', label: 'Ton' },
    ];

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setFormData({
            task: '',
            parent_material: '',
            item_description: '',
            unit: '',
            project_scope_quantity: '',
            upto_date_received: '',
            balance_to_be_procure: '',
            received_upto_previous_day: '',
            issued_upto_date: '',
            stock_as_on_date: '',
            issued_upto: '',
            stock_as_on: '',
            received_today: '',
            received_this_month: '',
            remarks: '',
            status: 'pending',
        });
        setErrors({});
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.item_description) newErrors.item_description = 'Item description is required';
        if (!formData.unit) newErrors.unit = 'Unit is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);

        try {
            const res = await axios.post(`${BASE_URL}/project_details/material/`, formData);
            if (res.status === 200 || res.status === 201) {
                handleClose();
                await getMaterialList();
                toast.success("Material added successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (value.trim()) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const handleDateChange = (name, date) => {
        setFormData(prev => ({ ...prev, [name]: date }));
    };

    const fetchDropdownData = async () => {
        try {
            const [tasksRes, materialsRes] = await Promise.all([
                axios.get(`${BASE_URL}/project_details/task/`),
                axios.get(`${BASE_URL}/project_details/material/`)
            ]);

            setTasks(tasksRes.data);
            setMaterials(materialsRes.data);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        if (show) fetchDropdownData();
    }, [show]);

    const taskOptions = tasks.map(t => ({
        value: t.id,
        label: t.task_name
    }));

    const materialOptions = materials.map(m => ({
        value: m.id,
        label: m.item_description || `Material-${m.id.substring(0, 8)}`
    }));

    return (
        <>
            <button
                title="Add Material"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Material
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Add Material</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            {/* Item Description */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Item Description <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Describe the material item"
                                    name="item_description"
                                    value={formData.item_description}
                                    onChange={handleInputChange}
                                    className="form-input"

                                />
                                {errors.item_description && <span className="error-message">{errors.item_description}</span>}
                            </div>

                            {/* Unit */}
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Unit <span className="required">*</span></label>
                                <select
                                    name="unit"
                                    value={formData.unit}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.unit ? 'error' : ''}`}
                                >
                                    <option value="">Select Unit</option>
                                    {unitOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                {errors.unit && <span className="error-message">{errors.unit}</span>}
                            </div>

                            {/* Task */}
                            <div className="flex-column form-group-select">
                                <label className="form-labels">Related Task</label>
                                <Select
                                    options={taskOptions}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            task: selected?.value || ''
                                        }))
                                    }
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                    placeholder="Select Task"
                                />
                            </div>

                            {/* Parent Material */}
                            <div className="flex-column form-group-select">
                                <label className="form-labels">Parent Material</label>
                                <Select
                                    options={materialOptions}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            parent_material: selected?.value || ''
                                        }))
                                    }
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                    placeholder="Select Parent Material"
                                />
                            </div>

                            {/* Quantity Fields */}
                            <div className="flex-column">
                                <label className="form-labels">Project Scope Quantity</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="project_scope_quantity"
                                    value={formData.project_scope_quantity}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Received Today</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="received_today"
                                    value={formData.received_today}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Received This Month</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="received_this_month"
                                    value={formData.received_this_month}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Upto Date Received</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="upto_date_received"
                                    value={formData.upto_date_received}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Balance to Procure</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="balance_to_be_procure"
                                    value={formData.balance_to_be_procure}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            {/* Date Fields */}
                            <div className="flex-column">
                                <label className="form-labels">Issued Upto Date</label>
                                <input
                                    type="date"
                                    name="issued_upto_date"
                                    value={formData.issued_upto_date}
                                    onChange={(e) => handleDateChange('issued_upto_date', e.target.value)}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Stock As On Date</label>
                                <input
                                    type="date"
                                    name="stock_as_on_date"
                                    value={formData.stock_as_on_date}
                                    onChange={(e) => handleDateChange('stock_as_on_date', e.target.value)}
                                    className="form-input"
                                />
                            </div>

                            {/* Status */}
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className="form-input form-group-selection"
                                >
                                    {statusOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                            </div>

                            {/* Remarks */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Remarks</label>
                                <input
                                    type="text"
                                    placeholder="Additional remarks"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                    className="form-input"

                                />
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? 'Adding...' : 'Add'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateMaterial = ({ material, getMaterialList, department_name }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [materials, setMaterials] = useState([]);

    const [formData, setFormData] = useState({
        task: material.task?.id || '',
        parent_material: material.parent_material?.id || '',
        item_description: material.item_description || '',
        unit: material.unit || '',
        project_scope_quantity: material.project_scope_quantity || '',
        upto_date_received: material.upto_date_received || '',
        balance_to_be_procure: material.balance_to_be_procure || '',
        received_upto_previous_day: material.received_upto_previous_day || '',
        issued_upto_date: material.issued_upto_date || '',
        stock_as_on_date: material.stock_as_on_date || '',
        issued_upto: material.issued_upto || '',
        stock_as_on: material.stock_as_on || '',
        received_today: material.received_today || '',
        received_this_month: material.received_this_month || '',
        remarks: material.remarks || '',
        status: material.status || 'pending',
    });

    const [errors, setErrors] = useState({});

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'inprogress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
    ];

    const unitOptions = [
        { value: 'kg', label: 'Kilogram' },
        { value: 'm', label: 'Meter' },
        { value: 'l', label: 'Liter' },
        { value: 'pc', label: 'Piece' },
        { value: 'ton', label: 'Ton' },
    ];

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setFormData({
            task: material.task?.id || '',
            parent_material: material.parent_material?.id || '',
            item_description: material.item_description || '',
            unit: material.unit || '',
            project_scope_quantity: material.project_scope_quantity || '',
            upto_date_received: material.upto_date_received || '',
            balance_to_be_procure: material.balance_to_be_procure || '',
            received_upto_previous_day: material.received_upto_previous_day || '',
            issued_upto_date: material.issued_upto_date || '',
            stock_as_on_date: material.stock_as_on_date || '',
            issued_upto: material.issued_upto || '',
            stock_as_on: material.stock_as_on || '',
            received_today: material.received_today || '',
            received_this_month: material.received_this_month || '',
            remarks: material.remarks || '',
            status: material.status || 'pending',
        });
        setErrors({});
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.item_description) newErrors.item_description = 'Item description is required';
        if (!formData.unit) newErrors.unit = 'Unit is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);

        try {
            const res = await axios.put(`${BASE_URL}/project_details/material/${material.id}/`, formData);
            if (res.status === 200 || res.status === 201) {
                handleClose();
                await getMaterialList();
                toast.success("Material updated successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (value.trim()) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const handleDateChange = (name, date) => {
        setFormData(prev => ({ ...prev, [name]: date }));
    };

    const fetchDropdownData = async () => {
        try {
            const [tasksRes, materialsRes] = await Promise.all([
                axios.get(`${BASE_URL}/project_details/task/`),
                axios.get(`${BASE_URL}/project_details/material/`)
            ]);

            setTasks(tasksRes.data);
            setMaterials(materialsRes.data);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        if (show) fetchDropdownData();
    }, [show]);

    const taskOptions = tasks.map(t => ({
        value: t.id,
        label: t.task_name
    }));

    const materialOptions = materials.map(m => ({
        value: m.id,
        label: m.item_description || `Material-${m.id.substring(0, 8)}`
    }));

    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Update Material</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            {/* Item Description */}
                            <div className="flex-column full-width-form">
                                <label className="form-labels">Item Description <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Describe the material item"
                                    name="item_description"
                                    value={formData.item_description}
                                    onChange={handleInputChange}
                                    className="form-input"

                                />
                                {errors.item_description && <span className="error-message">{errors.item_description}</span>}
                            </div>

                            {/* Unit */}
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Unit <span className="required">*</span></label>
                                <select
                                    name="unit"
                                    value={formData.unit}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.unit ? 'error' : ''}`}
                                >
                                    <option value="">Select Unit</option>
                                    {unitOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                {errors.unit && <span className="error-message">{errors.unit}</span>}
                            </div>

                            {/* Task */}
                            <div className="flex-column form-group-select">
                                <label className="form-labels">Related Task</label>
                                <Select
                                    options={taskOptions}
                                    value={taskOptions.find(opt => opt.value === formData.task)}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            task: selected?.value || ''
                                        }))
                                    }
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                    placeholder="Select Task"
                                />
                            </div>

                            {/* Parent Material */}
                            <div className="flex-column form-group-select">
                                <label className="form-labels">Parent Material</label>
                                <Select
                                    options={materialOptions}
                                    value={materialOptions.find(opt => opt.value === formData.parent_material)}
                                    onChange={(selected) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            parent_material: selected?.value || ''
                                        }))
                                    }
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                    placeholder="Select Parent Material"
                                />
                            </div>

                            {/* Quantity Fields */}
                            <div className="flex-column">
                                <label className="form-labels">Project Scope Quantity</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="project_scope_quantity"
                                    value={formData.project_scope_quantity}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Received Today</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="received_today"
                                    value={formData.received_today}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Received This Month</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="received_this_month"
                                    value={formData.received_this_month}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Upto Date Received</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="upto_date_received"
                                    value={formData.upto_date_received}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Balance to Procure</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter quantity"
                                    name="balance_to_be_procure"
                                    value={formData.balance_to_be_procure}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            {/* Date Fields */}
                            <div className="flex-column">
                                <label className="form-labels">Issued Upto Date</label>
                                <input
                                    type="date"
                                    name="issued_upto_date"
                                    value={formData.issued_upto_date}
                                    onChange={(e) => handleDateChange('issued_upto_date', e.target.value)}
                                    className="form-input"
                                />
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Stock As On Date</label>
                                <input
                                    type="date"
                                    name="stock_as_on_date"
                                    value={formData.stock_as_on_date}
                                    onChange={(e) => handleDateChange('stock_as_on_date', e.target.value)}
                                    className="form-input"
                                />
                            </div>

                            {/* Status */}
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className="form-input form-group-selection"
                                >
                                    {statusOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                            </div>

                            <div className="flex-column full-width-form">
                                <label className="form-labels">Remarks</label>
                                <input
                                    type="text"
                                    placeholder="Additional remarks"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                    className="form-input"

                                />
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? 'Updating...' : 'Update'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteMaterial = ({ material, getMaterialList }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleDelete = async () => {
        const loadingToastId = toast.loading("Deleting...");
        setLoading(true);
        try {
            const res = await axios.delete(`${BASE_URL}/project_details/material/${material.id}/`);
            if (res.status === 204) {
                handleClose();
                await getMaterialList();
                toast.success("Material deleted successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this material?
                    <br />
                    <strong>{material.item_description || `Material-${material.id.substring(0, 8)}`}</strong>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="model-button-cancel"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className="model-button-delete"
                        onClick={handleDelete}
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

const AddDailyProgress = ({ activityID, getProgressRecords }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [activities, setActivities] = useState([]);

    const [formData, setFormData] = useState({
        activity: activityID ? activityID.id : '',
        target_date: '',
        target_for_day: '',
        achieved_today: '',
    });

    const [errors, setErrors] = useState({});

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);

        setErrors({});
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.target_date) newErrors.target_date = 'Target date is required';
        if (!formData.target_for_day) newErrors.target_for_day = 'Target for day is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);

        try {
            const res = await axios.post(`${BASE_URL}/project_details/dailyprogressrecord/`, formData);
            if (res.status === 200 || res.status === 201) {
                handleClose();
                await getProgressRecords(activityID?.id);
                toast.success("Daily progress added successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (value.trim()) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const handleDateChange = (name, date) => {
        setFormData(prev => ({ ...prev, [name]: date }));
    };

    const fetchActivities = async () => {
        try {
            const activitiesRes = await axios.get(`${BASE_URL}/project_details/activity/`);
            setActivities(activitiesRes.data);
        } catch (error) {
            console.error('Error fetching activities:', error);
        }
    };

    useEffect(() => {
        if (show) fetchActivities();
    }, [show]);

    const activityOptions = activities.map(a => ({
        value: a.id,
        label: a.activity_name || `Activity-${a.id.substring(0, 8)}`
    }));

    return (
        <>
            <button
                title="Add Daily Progress"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Add Daily Progress</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>


                            {/* Target Date */}
                            <div className="flex-column">
                                <label className="form-labels">Target Date <span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="target_date"
                                    value={formData.target_date}
                                    onChange={(e) => handleDateChange('target_date', e.target.value)}
                                    className={`form-input ${errors.target_date ? 'error' : ''}`}
                                />
                                {errors.target_date && <span className="error-message">{errors.target_date}</span>}
                            </div>

                            {/* Target for Day */}
                            <div className="flex-column">
                                <label className="form-labels">Target for Day <span className="required">*</span></label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter target quantity"
                                    name="target_for_day"
                                    value={formData.target_for_day}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.target_for_day ? 'error' : ''}`}
                                />
                                {errors.target_for_day && <span className="error-message">{errors.target_for_day}</span>}
                            </div>

                            {/* Achieved Today */}
                            <div className="flex-column">
                                <label className="form-labels">Achieved Today</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter achieved quantity"
                                    name="achieved_today"
                                    value={formData.achieved_today}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? 'Adding...' : 'Add Progress'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const EditDailyProgress = ({ i, activityID, getProgressRecords }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [activities, setActivities] = useState([]);

    const [formData, setFormData] = useState({
        activity: activityID ? activityID : '',
        target_date: '',
        target_for_day: '',
        achieved_today: '',
    });

    const [errors, setErrors] = useState({});

    const handleShow = () => {
        setShow(true)
        setFormData(i)
    };
    const handleClose = () => {
        setShow(false);
        setFormData({
            activity: '',
            target_date: '',
            target_for_day: '',
            achieved_today: '',
        });
        setErrors({});
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.activity) newErrors.activity = 'Activity is required';
        if (!formData.target_date) newErrors.target_date = 'Target date is required';
        if (!formData.target_for_day) newErrors.target_for_day = 'Target for day is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);

        try {
            const res = await axios.put(`${BASE_URL}/project_details/dailyprogressrecordputdelete/${i?.id}`, formData);
            if (res.status === 200 || res.status === 201) {
                handleClose();
                await getProgressRecords(i?.id);
                toast.success("Daily progress added successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (value.trim()) {
            setErrors(prev => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const handleDateChange = (name, date) => {
        setFormData(prev => ({ ...prev, [name]: date }));
    };

    const fetchActivities = async () => {
        try {
            const activitiesRes = await axios.get(`${BASE_URL}/project_details/activity/`);
            setActivities(activitiesRes.data);
        } catch (error) {
            console.error('Error fetching activities:', error);
        }
    };

    useEffect(() => {
        if (show) fetchActivities();
    }, [show]);

    const activityOptions = activities.map(a => ({
        value: a.id,
        label: a.activity_name || `Activity-${a.id.substring(0, 8)}`
    }));

    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Add Daily Progress</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>


                            {/* Target Date */}
                            <div className="flex-column">
                                <label className="form-labels">Target Date <span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="target_date"
                                    value={formData.target_date}
                                    onChange={(e) => handleDateChange('target_date', e.target.value)}
                                    className={`form-input ${errors.target_date ? 'error' : ''}`}
                                />
                                {errors.target_date && <span className="error-message">{errors.target_date}</span>}
                            </div>

                            {/* Target for Day */}
                            <div className="flex-column">
                                <label className="form-labels">Target for Day <span className="required">*</span></label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter target quantity"
                                    name="target_for_day"
                                    value={formData.target_for_day}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.target_for_day ? 'error' : ''}`}
                                />
                                {errors.target_for_day && <span className="error-message">{errors.target_for_day}</span>}
                            </div>

                            {/* Achieved Today */}
                            <div className="flex-column">
                                <label className="form-labels">Achieved Today</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    placeholder="Enter achieved quantity"
                                    name="achieved_today"
                                    value={formData.achieved_today}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button
                                type="submit"
                                className="model-button-add"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? 'Adding...' : 'Add Progress'}
                            </button>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button-cancel"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};
const DeleteDailyProgress = ({ i, activityID, getProgressRecords }) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleDelete = async () => {
        const loadingToastId = toast.loading("Deleting...");
        setLoading(true);
        try {
            const res = await axios.delete(`${BASE_URL}/project_details/dailyprogressrecordputdelete/${i.id}/`);
            if (res.status === 200 || res.status === 201) {
                handleClose();
                await getProgressRecords(i?.id);
                toast.success("Daily Progress deleted successfully!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this Progress?

                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="model-button-cancel"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className="model-button-delete"
                        onClick={handleDelete}
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

const ViewDailyProgress = ({ i, activityId, getProgressRecords }) => {
    const [show, setShow] = useState(false);
    const [progressData, setProgressData] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    // Fetch progress data when modal opens
    useEffect(() => {
        if (show) {
            fetchProgressData();
        }
    }, [show]);

    const fetchProgressData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/project_details/dailyprogrerecordfilterbyactivity/${i?.id}/`);
            setProgressData(res.data);
        } catch (error) {
            console.error('Error fetching progress data:', error);
            toast.error('Failed to load progress data');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <button
                title="View Daily Progress"
                className="view-btn"
                onClick={handleShow}
            >
                <Eye />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new" style={{ overflowX: 'scroll' }}>
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Daily Progress Details</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : progressData && progressData.length > 0 ? (
                        <div className="progress-details-table">
                            <table>
                                <thead className="table-heading">
                                    <tr className="custom-table-head-tr">
                                        <th className="table-heading-text">S. No</th>
                                        <th className="table-heading-text">Target Date</th>
                                        <th className="table-heading-text">Target for Day</th>
                                        <th className="table-heading-text">Achieved Today</th>
                                        <th className="table-heading-text">Shortfall/Excess Today</th>
                                        <th className="table-heading-text text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {progressData.map((item, index) => (
                                        <tr key={item.id || index} className="custom-table-head-td">
                                            <td className="table-body text-center">{index + 1}</td>
                                            <td className="table-body text-center">
                                                {item.target_date
                                                    ? new Date(item.target_date).toLocaleDateString()
                                                    : "-"}
                                            </td>
                                            <td className="table-body text-center">{item.target_for_day || "-"}</td>
                                            <td className="table-body text-center">{item.achieved_today || "-"}</td>
                                            <td className="table-body text-center">
                                                {item.shortfall_excess_today !== undefined
                                                    ? `${item.shortfall_excess_today}%`
                                                    : "-"}
                                            </td>

                                            <td className="table-body text-center">
                                                <EditDailyProgress i={item} activityID={i} getProgressRecords={fetchProgressData} />
                                                <DeleteDailyProgress i={item} activityID={i} getProgressRecords={fetchProgressData} />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="text-center">
                            <p>No progress data available</p>
                        </div>
                    )}


                    <div className="button-models-add mt-3">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="model-button-cancel"
                        >
                            Close
                        </button>
                    </div>
                </Modal.Body>
            </Modal>


        </>
    );
};

// Eye icon component (if you don't have one already)
const EyeIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 3.5C3 3.5 1 8 1 8s2 4.5 7 4.5S15 8 15 8s-2-4.5-7-4.5z" />
        <circle cx="8" cy="8" r="2" />
    </svg>
);
export {
    AddActivity,
    AddDepartment,
    EditActivity, EditDepartment, DepartmentDelete, ActivityDelete, AddTask, UpdateTask,
    AddSubActivity,
    SubActivityModal, SubTaskModal, AddSubtask, DeleteTask, AddMOM,
    UpdateMOM,
    DeleteMOM,

    AddTaskActivity,
    UpdateTaskActivity,
    DeleteTaskActivity,

    AddROB,
    UpdateROB,
    DeleteROB,

    AddMaterial,
    UpdateMaterial,
    DeleteMaterial,

    AddDailyProgress,
    EditDailyProgress,
    DeleteDailyProgress,

    ViewDailyProgress,
}